
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4S3gx", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => (parcelRequire("l7rln")).featureFlagsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $l7rln = parcelRequire("l7rln");

});
parcelRegister("l7rln", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => $8eb28bf449dbd43f$export$79626a094e303f80);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");
const $8eb28bf449dbd43f$var$pluginKey = new (0, $7T7aA.PluginKey)('featureFlags');
const $8eb28bf449dbd43f$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $8eb28bf449dbd43f$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            key: $8eb28bf449dbd43f$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});


parcelRegister("kbe7k", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => $62c1068719723e82$export$43b392516e89a467);

var $apksR = parcelRequire("apksR");
const $62c1068719723e82$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $apksR.pluginKey), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $apksR.pluginKey).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $apksR.createPlugin)(config, api)
                }
            ];
        }
    };
};

});
parcelRegister("apksR", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1bf41817841eac5e$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $1bf41817841eac5e$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");
const $1bf41817841eac5e$export$18d4026d1ea86bb1 = new (0, $7T7aA.PluginKey)('contextIdentiferPlugin');
async function $1bf41817841eac5e$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $1bf41817841eac5e$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $1bf41817841eac5e$var$updateContextIdentifier(initialConfig, api);
        return new (0, $1S4f7.SafePlugin)({
            key: $1bf41817841eac5e$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($1bf41817841eac5e$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };

});


parcelRegister("7nKrc", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPlugin", () => $9f031664f93dee36$export$b621d761b94834de);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $d925B = parcelRequire("d925B");

var $1S4f7 = parcelRequire("1S4f7");

var $lNDSG = parcelRequire("lNDSG");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $2gH2F = parcelRequire("2gH2F");

var $al42B = parcelRequire("al42B");

var $dArLd = parcelRequire("dArLd");

var $gTFHy = parcelRequire("gTFHy");

var $4b4oh = parcelRequire("4b4oh");

var $eQfrk = parcelRequire("eQfrk");
const $9f031664f93dee36$var$getToolbarDocking = (contextualFormattingEnabled, userPreferencesProvider)=>{
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') ?? 'none';
    return 'top';
};
const $9f031664f93dee36$var$getToolbarDockingV2 = (contextualFormattingEnabled, dockingPreference)=>{
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return dockingPreference ?? 'none';
    return 'top';
};
const $9f031664f93dee36$export$b621d761b94834de = ({ api: api, config: config })=>{
    const __selectionToolbarHandlers = [];
    let primaryToolbarComponent;
    const { userPreferencesProvider: userPreferencesProvider, contextualFormattingEnabled: contextualFormattingEnabled } = config;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls_toolbar_pinning_exp', true)) {
            primaryToolbarComponent = ({ disabled: disabled })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eQfrk.PrimaryToolbarComponentNew), {
                    api: api,
                    disabled: disabled
                });
            };
            api?.primaryToolbar?.actions.registerComponent({
                name: 'pinToolbar',
                component: primaryToolbarComponent
            });
        } else {
            primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eQfrk.PrimaryToolbarComponent), {
                    api: api,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement
                });
            api?.primaryToolbar?.actions.registerComponent({
                name: 'overflowMenu',
                component: primaryToolbarComponent
            });
        }
    }
    let previousToolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') || null;
    let isPreferenceInitialized = false;
    return {
        name: 'selectionToolbar',
        actions: {
            suppressToolbar: ()=>{
                return api?.core.actions.execute((0, $2gH2F.toggleToolbar)({
                    hide: true
                })) ?? false;
            },
            unsuppressToolbar: ()=>{
                return api?.core.actions.execute((0, $2gH2F.toggleToolbar)({
                    hide: false
                })) ?? false;
            },
            setToolbarDocking: (toolbarDocking)=>{
                if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking)) ?? false;
                return api?.core.actions.execute((0, $2gH2F.setToolbarDocking)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                })) ?? false;
            },
            forceToolbarDockingWithoutAnalytics: (toolbarDocking)=>{
                return api?.core.actions.execute((0, $2gH2F.forceToolbarDockingWithoutAnalytics)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider
                })) ?? false;
            },
            refreshToolbarDocking: ()=>{
                if (userPreferencesProvider) {
                    const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                    return api?.core.actions.execute((0, $2gH2F.updateToolbarDocking)({
                        toolbarDocking: userToolbarDockingPref
                    })) ?? false;
                }
                return false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $al42B.selectionToolbarPluginKey).getState(editorState);
        },
        pmPlugins (selectionToolbarHandlers) {
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            const initialToolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? $9f031664f93dee36$var$getToolbarDockingV2(contextualFormattingEnabled, api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition) : $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: (0, $al42B.selectionToolbarPluginKey),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false,
                                        hide: false,
                                        toolbarDocking: initialToolbarDocking
                                    };
                                },
                                apply (tr, pluginState) {
                                    const meta = tr.getMeta((0, $al42B.selectionToolbarPluginKey));
                                    if (meta) return {
                                        ...pluginState,
                                        ...meta
                                    };
                                    // if the toolbarDockingInitialPosition preference has changed
                                    // update the toolbarDocking state
                                    if (!previousToolbarDocking && (0, $dh538.fg)('platform_editor_controls_patch_4')) {
                                        // we currently only check for the initial value
                                        const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                        if (toolbarDockingPreference && toolbarDockingPreference !== previousToolbarDocking) {
                                            previousToolbarDocking = toolbarDockingPreference;
                                            const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                            if (pluginState.toolbarDocking !== userToolbarDockingPref) return {
                                                ...pluginState,
                                                toolbarDocking: userToolbarDockingPref
                                            };
                                        }
                                    }
                                    return pluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $d8F95.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: ()=>{
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $d8F95.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            appendTransaction (_transactions, _oldState, newState) {
                                if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return null;
                                if (!isPreferenceInitialized && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_2')) {
                                    const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                    if (toolbarDockingPreference !== undefined) {
                                        isPreferenceInitialized = true;
                                        const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                        const tr = newState.tr;
                                        if (!(0, $dh538.fg)('platform_editor_controls_patch_4')) tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            toolbarDocking: userToolbarDockingPref
                                        });
                                        api?.analytics?.actions.attachAnalyticsEvent({
                                            action: (0, $d925B.ACTION).INITIALISED,
                                            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
                                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                                            attributes: {
                                                toolbarDocking: userToolbarDockingPref
                                            },
                                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                                        })(tr);
                                        return tr;
                                    }
                                }
                                return null;
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable, hide: hide, toolbarDocking: toolbarDocking } = (0, $al42B.selectionToolbarPluginKey).getState(state);
                const isCellSelection = '$anchorCell' in state.selection;
                const isEditorControlsEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
                if (state.selection.empty || !selectionStable || hide || state.selection instanceof (0, $7T7aA.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                isCellSelection && !isEditorControlsEnabled // for Editor Controls we want to show the toolbar on CellSelection
                ) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                if (isCellSelection && isEditorControlsEnabled && (0, $dh538.fg)('platform_editor_controls_patch_5')) {
                    const isSelectedViaDragHandle = api?.blockControls?.sharedState.currentState()?.isSelectedViaDragHandle;
                    if (isSelectedViaDragHandle) return;
                }
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    // add a seperator icon after each group except the last
                    if (Array.isArray(resolved[i]?.items)) items.push(...resolved[i].items);
                    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                        if (resolved[i] && resolved[i + 1]) {
                            if (resolved[i + 1]?.pluginName === 'annotation') items.push({
                                type: 'separator',
                                fullHeight: true
                            });
                        }
                    } else if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                if (items.length > 0 && contextualFormattingEnabled && isEditorControlsEnabled) {
                    const toolbarDockingPref = api?.userPreferences && (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : toolbarDocking;
                    if ((0, $iu6m9.editorExperiment)('platform_editor_controls_toolbar_pinning_exp', true)) items.push(...(0, $4b4oh.getPinOptionToolbarConfig)({
                        api: api,
                        toolbarDocking: toolbarDockingPref,
                        intl: intl
                    }));
                    else items.push(...(0, $dArLd.getOverflowFloatingToolbarConfig)({
                        api: api,
                        toolbarDocking: toolbarDockingPref,
                        intl: intl
                    }));
                }
                let onPositionCalculated;
                const toolbarTitle = 'Selection toolbar';
                if (isCellSelection && isEditorControlsEnabled) onPositionCalculated = (0, $lNDSG.calculateToolbarPositionOnCellSelection)(toolbarTitle);
                else {
                    const calcToolbarPosition = config.preferenceToolbarAboveSelection ? (0, $lNDSG.calculateToolbarPositionAboveSelection) : (0, $lNDSG.calculateToolbarPositionTrackHead);
                    onPositionCalculated = calcToolbarPosition(toolbarTitle);
                }
                const nodeType = $9f031664f93dee36$var$getSelectionNodeTypes(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    ...isEditorControlsEnabled && {
                        scrollable: true
                    },
                    onPositionCalculated: onPositionCalculated
                };
            }
        },
        contentComponent: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $dh538.fg)('platform_editor_use_preferences_plugin') && (0, $dh538.fg)('platform_editor_user_preferences_provider_update') ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gTFHy.PageVisibilityWatcher), {
                api: api,
                userPreferencesProvider: userPreferencesProvider
            }) : undefined,
        primaryToolbarComponent: !api?.primaryToolbar && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? primaryToolbarComponent : undefined
    };
};
function $9f031664f93dee36$var$getSelectionNodeTypes(state) {
    const selectionNodeTypes = [];
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}

});
parcelRegister("2gH2F", function(module, exports) {

$parcel$export(module.exports, "toggleToolbar", () => $35ef7d1ba42c2fa2$export$9bf0179b815bb489);
$parcel$export(module.exports, "updateToolbarDocking", () => $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f);
$parcel$export(module.exports, "setToolbarDocking", () => $35ef7d1ba42c2fa2$export$c90257e445702eb2);
$parcel$export(module.exports, "forceToolbarDockingWithoutAnalytics", () => $35ef7d1ba42c2fa2$export$93bfa5da95924fe8);

var $d925B = parcelRequire("d925B");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $al42B = parcelRequire("al42B");
const $35ef7d1ba42c2fa2$export$9bf0179b815bb489 = ({ hide: hide })=>({ tr: tr })=>{
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            hide: hide
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f = ({ toolbarDocking: toolbarDocking })=>({ tr: tr })=>{
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$c90257e445702eb2 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        // We currently ignore any update failures, need to confirm this is the desired behaviour
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        if (toolbarDocking === 'top') // Remove the selection if the toolbar is docked to the top
        tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, tr.selection.head));
        if ((0, $dh538.fg)('platform_editor_controls_patch_2')) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).UPDATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: toolbarDocking
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $35ef7d1ba42c2fa2$export$93bfa5da95924fe8 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider })=>({ tr: tr })=>{
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $al42B.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };

});
parcelRegister("al42B", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPluginKey", () => $a54f7f7e66db851d$export$b382528b8197b4f1);

var $7T7aA = parcelRequire("7T7aA");
const $a54f7f7e66db851d$export$b382528b8197b4f1 = new (0, $7T7aA.PluginKey)('selectionToolbarPluginKey');

});


parcelRegister("dArLd", function(module, exports) {

$parcel$export(module.exports, "getOverflowFloatingToolbarConfig", () => $96a6ba033b702f63$export$547d4856c8150a9d);
$parcel$export(module.exports, "getOverflowPrimaryToolbarConfig", () => $96a6ba033b702f63$export$4c3311b0c1b6b110);
/* overflow-toolbar-config.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5dODy = parcelRequire("5dODy");

var $iSCwd = parcelRequire("iSCwd");

var $cvXh8 = parcelRequire("cvXh8");

var $5Yp2m = parcelRequire("5Yp2m");

var $gBbsI = parcelRequire("gBbsI");

var $dh538 = parcelRequire("dh538");
const $96a6ba033b702f63$export$547d4856c8150a9d = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    const isDockedToTop = toolbarDocking === 'top';
    const dropdownOptions = [
        {
            type: 'overflow-dropdown-heading',
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarAppears)
        },
        {
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionInline),
            onClick: ()=>{
                if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions?.updateUserPreference?.('toolbarDockingPosition', 'none')) ?? false;
                return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))({
                label: ''
            }),
            selected: !isDockedToTop,
            elemAfter: !isDockedToTop ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "",
                size: "small"
            }) : undefined
        },
        {
            title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionFixedAtTop),
            onClick: ()=>{
                if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions?.updateUserPreference?.('toolbarDockingPosition', 'top')) ?? false;
                return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iSCwd)))({
                label: ''
            }),
            selected: isDockedToTop,
            elemAfter: isDockedToTop ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "",
                size: "small"
            }) : undefined
        }
    ];
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const testId = (0, $dh538.fg)('platform_editor_controls_patch_8') ? 'selectionToolbar-overflow-dropdown-trigger' : undefined;
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        {
            type: 'overflow-dropdown',
            testId: testId,
            dropdownWidth: 240,
            options: dropdownOptions
        }
    ];
};
const $96a6ba033b702f63$export$4c3311b0c1b6b110 = ({ api: api, intl: intl })=>[
        {
            items: [
                {
                    content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gBbsI.default), {
                        children: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarAppears)
                    }),
                    value: {
                        name: ''
                    },
                    isDisabled: true
                },
                {
                    content: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionInline),
                    value: {
                        name: 'contextual'
                    },
                    onClick: ()=>{
                        if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions?.updateUserPreference?.('toolbarDockingPosition', 'none')) ?? false;
                        return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
                    },
                    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))({
                        label: ''
                    })
                },
                {
                    content: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionFixedAtTop),
                    value: {
                        name: 'fixed'
                    },
                    onClick: ()=>{
                        if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions?.updateUserPreference?.('toolbarDockingPosition', 'top')) ?? false;
                        return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
                    },
                    isActive: true,
                    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($iSCwd)))({
                        label: ''
                    }),
                    elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                        label: "",
                        size: "small"
                    })
                }
            ]
        }
    ];

});
parcelRegister("iSCwd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4ecfaa2a7affab0b723faa26877e5072>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbeb2621c43b09f2$var$_react = $dbeb2621c43b09f2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $dbeb2621c43b09f2$var$_baseNew = $dbeb2621c43b09f2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dbeb2621c43b09f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DockToolbarTop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for docking a toolbar to the top of a page
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbeb2621c43b09f2$var$DockToolbarTopIcon = (props)=>/*#__PURE__*/ $dbeb2621c43b09f2$var$_react.default.createElement($dbeb2621c43b09f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9 3H4V4h8z" clip-rule="evenodd"/>`
    }, props));
$dbeb2621c43b09f2$var$DockToolbarTopIcon.displayName = 'DockToolbarTopIcon';
var $dbeb2621c43b09f2$var$_default = module.exports.default = $dbeb2621c43b09f2$var$DockToolbarTopIcon;

});


parcelRegister("gTFHy", function(module, exports) {

$parcel$export(module.exports, "PageVisibilityWatcher", () => $3f59dbd744c5a7fd$export$57bf1011afa72cdf);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $hWRJP = parcelRequire("hWRJP");

var $iu6m9 = parcelRequire("iu6m9");
const $3f59dbd744c5a7fd$export$57bf1011afa72cdf = ({ api: api, userPreferencesProvider: userPreferencesProvider })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!userPreferencesProvider || !api) return;
        const refreshPrefrerence = async ()=>{
            if (document.visibilityState === 'visible') {
                try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $hWRJP.logException)(error, {
                        location: 'editor-plugin-selection-toolbar/PageVisibilityWatcher'
                    });
                }
                api?.selectionToolbar?.actions?.refreshToolbarDocking?.();
            }
        };
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls_performance_fixes', false)) refreshPrefrerence();
        return (0, $d8F95.bind)(document, {
            type: 'visibilitychange',
            listener: refreshPrefrerence
        });
    }, [
        api,
        userPreferencesProvider
    ]);
    return null;
};

});

parcelRegister("4b4oh", function(module, exports) {

$parcel$export(module.exports, "getPinOptionToolbarConfig", () => $3c3fb9945e9e8cc1$export$c9b144c567898dd8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5dODy = parcelRequire("5dODy");

var $6V1ly = parcelRequire("6V1ly");

var $brxEJ = parcelRequire("brxEJ");
const $3c3fb9945e9e8cc1$export$c9b144c567898dd8 = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
    let pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.unpined',
        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        type: 'button'
    };
    const isDockedToTop = toolbarDocking === 'top';
    if (isDockedToTop) pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.pinedToTop',
        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
        },
        type: 'button',
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop)
    };
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        pinButton
    ];
};

});

parcelRegister("eQfrk", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $321ab3976fd6480f$export$94516d5cccf573e3);
$parcel$export(module.exports, "PrimaryToolbarComponentNew", () => $321ab3976fd6480f$export$e6358524deb30d58);
/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $61p3e = parcelRequire("61p3e");
var $5dODy = parcelRequire("5dODy");

var $5v8Ta = parcelRequire("5v8Ta");
var $h4TOP = parcelRequire("h4TOP");
var $a4eZN = parcelRequire("a4eZN");

var $b3YrF = parcelRequire("b3YrF");

var $6V1ly = parcelRequire("6V1ly");

var $brxEJ = parcelRequire("brxEJ");

var $9VJDA = parcelRequire("9VJDA");

var $dh538 = parcelRequire("dh538");

var $dArLd = parcelRequire("dArLd");
const $321ab3976fd6480f$var$DROPDOWN_WIDTH = 240;
const $321ab3976fd6480f$var$buttonStyles = null;
function $321ab3976fd6480f$export$94516d5cccf573e3({ api: api, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
    const intl = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const items = (0, $gwFzn.useMemo)(()=>(0, $dArLd.getOverflowPrimaryToolbarConfig)({
            api: api,
            intl: intl
        }), [
        api,
        intl
    ]);
    const content = intl.formatMessage((0, $61p3e.default).viewMore);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onMenuItemActivated = (0, $gwFzn.useCallback)(({ item: item })=>{
        item?.onClick?.();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_controls_patch_4')) api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DOCKED_PRIMARY_TOOLBAR,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h4TOP.default), {
        isOpen: isOpen,
        onOpenChange: (attrs)=>setIsOpen(attrs.isOpen),
        items: items,
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
        },
        boundariesElement: popupsBoundariesElement,
        mountTo: popupsMountPoint,
        scrollableElement: popupsScrollableElement,
        section: {
            hasSeparator: true
        },
        onItemActivated: onMenuItemActivated,
        fitWidth: $321ab3976fd6480f$var$DROPDOWN_WIDTH,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
            onClick: onClick,
            "aria-haspopup": "dialog",
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.addLink)),
            "aria-label": content,
            title: content,
            className: (0, $35pXk.default)([
                "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: content
            })
        })
    });
}
const $321ab3976fd6480f$export$e6358524deb30d58 = ({ api: api, disabled: disabled })=>{
    const intl = (0, $dBxQj.default)();
    const mode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const isOffline = mode === 'offline' || false;
    const isDockedToTop = api?.selectionToolbar.sharedState.currentState()?.toolbarDocking === 'top';
    if (isDockedToTop) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
        "aria-label": intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.selectionToolbar.actions?.setToolbarDocking?.('none') ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop),
        className: (0, $35pXk.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
        "aria-label": intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.selectionToolbar.actions?.setToolbarDocking?.('top') ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        className: (0, $35pXk.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
};

});


parcelRegister("itirX", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => $e505b2a6e9f3b5fd$export$ad7799fd22a76abd);

var $46rVE = parcelRequire("46rVE");

var $dqpsa = parcelRequire("dqpsa");

var $hqUzz = parcelRequire("hqUzz");
const $e505b2a6e9f3b5fd$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $hqUzz.default));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $46rVE.registerComponent)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $dqpsa.createPlugin)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config?.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $dqpsa.primaryToolbarPluginKey).getState(editorState);
        }
    };
};

});
parcelRegister("46rVE", function(module, exports) {

$parcel$export(module.exports, "registerComponent", () => $ce844b7854732342$export$d74092cddf07c0aa);
const $ce844b7854732342$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };

});

parcelRegister("dqpsa", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPluginKey", () => $61a61062142b6645$export$36f60c8b3eb879ae);
$parcel$export(module.exports, "createPlugin", () => $61a61062142b6645$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $5YgfN = parcelRequire("5YgfN");
const $61a61062142b6645$export$36f60c8b3eb879ae = new (0, $7T7aA.PluginKey)('primaryToolbar');
const $61a61062142b6645$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $61a61062142b6645$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $5YgfN.getToolbarComponents)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};

});
parcelRegister("5YgfN", function(module, exports) {

$parcel$export(module.exports, "getToolbarComponents", () => $7aa852d107b41e9c$export$a758406ca53b86a5);

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $7aa852d107b41e9c$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        const shouldShowUndoRedoGroup = (0, $dh538.fg)('platform_editor_undo_redo_find_on_primary_toolbar');
        configuration = $7aa852d107b41e9c$var$toolbarConfigurationV2(true, shouldShowUndoRedoGroup);
    } else {
        const shouldShowFindGroup = !!contextualFormattingEnabled;
        configuration = $7aa852d107b41e9c$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $7aa852d107b41e9c$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $7aa852d107b41e9c$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $7aa852d107b41e9c$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $7aa852d107b41e9c$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $7aa852d107b41e9c$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $7aa852d107b41e9c$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $7aa852d107b41e9c$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $7aa852d107b41e9c$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $7aa852d107b41e9c$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $7aa852d107b41e9c$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $7aa852d107b41e9c$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$7aa852d107b41e9c$var$undoRedoGroup,
        ...$7aa852d107b41e9c$var$spellCheckGroup,
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$others : $7aa852d107b41e9c$var$othersGroupNoFind
    ];
const $7aa852d107b41e9c$var$overflowMenu = [
    {
        name: 'overflowMenu'
    }
];
const $7aa852d107b41e9c$var$pinToolbar = [
    {
        name: 'pinToolbar'
    }
];
const $7aa852d107b41e9c$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowUndoRedoGroup, shouldShowFindGroup = false)=>[
        ...shouldShowUndoRedoGroup ? $7aa852d107b41e9c$var$undoRedoGroup : [],
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $7aa852d107b41e9c$var$insertBlockGroup : [],
        ...(0, $iu6m9.editorExperiment)('platform_editor_controls_toolbar_pinning_exp', true, {
            exposure: true
        }) ? $7aa852d107b41e9c$var$pinToolbar : $7aa852d107b41e9c$var$overflowMenu,
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$findGroup : []
    ];

});


parcelRegister("hqUzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f8db87568333ef$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $cORDs = parcelRequire("cORDs");
var $92f8db87568333ef$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $cORDs.wrapperStyle)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $cORDs.separatorStyles)
    }));

});


parcelRegister("b167b", function(module, exports) {

$parcel$export(module.exports, "transformNonTextNodesToText", () => $e4a271b9e519cf8b$export$abc5e6e01568db39);
$parcel$export(module.exports, "applyMarkOnRange", () => $e4a271b9e519cf8b$export$94a1aa532f5398df);
$parcel$export(module.exports, "entireSelectionContainsMark", () => $e4a271b9e519cf8b$export$cc5a5f0a00f537f5);
$parcel$export(module.exports, "toggleMark", () => $e4a271b9e519cf8b$export$797ad2667b8015a8);
$parcel$export(module.exports, "removeMark", () => $e4a271b9e519cf8b$export$5c9d031211c1b7c9);

var $7T7aA = parcelRequire("7T7aA");

var $7XFGZ = parcelRequire("7XFGZ");

var $dh538 = parcelRequire("dh538");
const $e4a271b9e519cf8b$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e4a271b9e519cf8b$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($e4a271b9e519cf8b$var$SMART_TO_ASCII).join('')}]`, 'g');
function $e4a271b9e519cf8b$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
function $e4a271b9e519cf8b$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($e4a271b9e519cf8b$var$FIND_SMART_CHAR, (match)=>$e4a271b9e519cf8b$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $e4a271b9e519cf8b$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $e4a271b9e519cf8b$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $e4a271b9e519cf8b$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
const $e4a271b9e519cf8b$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = $e4a271b9e519cf8b$export$cc5a5f0a00f537f5(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $e4a271b9e519cf8b$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = $e4a271b9e519cf8b$export$cc5a5f0a00f537f5(mark, tr.doc, $from.pos, $to.pos);
            $e4a271b9e519cf8b$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $e4a271b9e519cf8b$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $7T7aA.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $e4a271b9e519cf8b$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
const $e4a271b9e519cf8b$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $7T7aA.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };

});

parcelRegister("5mDFx", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => $bc1eab28a45a6e54$export$2db686be056cb923);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $87gxy = parcelRequire("87gxy");
var $6YcE1 = parcelRequire("6YcE1");
var $9vUG3 = parcelRequire("9vUG3");
var $2bddB = parcelRequire("2bddB");
var $5s90Q = parcelRequire("5s90Q");
var $ShNRe = parcelRequire("ShNRe");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $crqpF = parcelRequire("crqpF");

var $9Xhug = parcelRequire("9Xhug");

var $4Mpmq = parcelRequire("4Mpmq");

var $jbSWP = parcelRequire("jbSWP");

var $g7Q9y = parcelRequire("g7Q9y");

var $eWbSm = parcelRequire("eWbSm");

var $71c8N = parcelRequire("71c8N");

var $b1cfE = parcelRequire("b1cfE");

var $7Ey9C = parcelRequire("7Ey9C");

var $3Ce1I = parcelRequire("3Ce1I");

var $1Ypz8 = parcelRequire("1Ypz8");
const $bc1eab28a45a6e54$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_toolbar_rerender_optimization_exp', true, {
            exposure: true
        })) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Ypz8.PrimaryToolbarComponentMemoized), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Ypz8.PrimaryToolbarComponent), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $6YcE1.em)
                },
                {
                    name: 'strong',
                    mark: (0, $2bddB.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $9vUG3.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $87gxy.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $5s90Q.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $ShNRe.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $71c8N.plugin)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $jbSWP.default)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $g7Q9y.default)(schema, api?.analytics?.actions, api)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $7Ey9C.default)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $crqpF.plugin)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $9Xhug.default)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $eWbSm.default)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const textFormattingState = (0, $b1cfE.pluginKey).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (0, $crqpF.pluginKey).getState(editorState)?.formattingIsPresent,
                isInitialised: !!textFormattingState?.isInitialised
            };
        },
        pluginsOptions: {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Ce1I.FloatingToolbarTextFormalWithIntl), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api?.analytics?.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $4Mpmq.toggleSuperscriptWithAnalytics)(api?.analytics?.actions),
            toggleSubscript: (0, $4Mpmq.toggleSubscriptWithAnalytics)(api?.analytics?.actions),
            toggleStrike: (0, $4Mpmq.toggleStrikeWithAnalytics)(api?.analytics?.actions),
            toggleCode: (0, $4Mpmq.toggleCodeWithAnalytics)(api?.analytics?.actions),
            toggleUnderline: (0, $4Mpmq.toggleUnderlineWithAnalytics)(api?.analytics?.actions),
            toggleEm: (0, $4Mpmq.toggleEmWithAnalytics)(api?.analytics?.actions),
            toggleStrong: (0, $4Mpmq.toggleStrongWithAnalytics)(api?.analytics?.actions)
        }
    };
};

});
parcelRegister("crqpF", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "plugin", () => $c4b62bb81a4e5eb6$export$ca524d3785e2543);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $9pAUz = parcelRequire("9pAUz");
const $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1 = new (0, $7T7aA.PluginKey)('clearFormattingPlugin');
const $c4b62bb81a4e5eb6$export$ca524d3785e2543 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $9pAUz.checkFormattingIsPresent)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $9pAUz.checkFormattingIsPresent)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($c4b62bb81a4e5eb6$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1
    });

});
parcelRegister("9pAUz", function(module, exports) {

$parcel$export(module.exports, "hasCode", () => $b6372db181ff20ac$export$435b7561880b778c);
$parcel$export(module.exports, "markActive", () => $b6372db181ff20ac$export$c91f8b3cbd625635);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $b6372db181ff20ac$export$4b48a1fc423972ea);
$parcel$export(module.exports, "compareItemsArrays", () => $b6372db181ff20ac$export$53d327693050b221);
$parcel$export(module.exports, "isArrayContainsContent", () => $b6372db181ff20ac$export$f8f79f933a3fce55);

var $l6xRR = parcelRequire("l6xRR");

var $6iA9F = parcelRequire("6iA9F");
const $b6372db181ff20ac$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $b6372db181ff20ac$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $b6372db181ff20ac$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $6iA9F.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $b6372db181ff20ac$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $6iA9F.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $l6xRR.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $b6372db181ff20ac$export$4b48a1fc423972ea = (state)=>{
    return $b6372db181ff20ac$var$marksArePresent(state) || $b6372db181ff20ac$var$blockStylingIsPresent(state);
};
const $b6372db181ff20ac$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $b6372db181ff20ac$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;

});
parcelRegister("6iA9F", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $259f2a142ea36336$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $259f2a142ea36336$export$73b50f8f13648c71);
$parcel$export(module.exports, "clearFormattingWithAnalytics", () => $259f2a142ea36336$export$332a1f720fc2ba0);

var $d925B = parcelRequire("d925B");

var $4FvAQ = parcelRequire("4FvAQ");

var $7XFGZ = parcelRequire("7XFGZ");

var $lbH5M = parcelRequire("lbH5M");
const $259f2a142ea36336$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $259f2a142ea36336$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $259f2a142ea36336$var$formatTypes = {
    em: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $259f2a142ea36336$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $259f2a142ea36336$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
function $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $4FvAQ.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $259f2a142ea36336$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $259f2a142ea36336$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $lbH5M.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $259f2a142ea36336$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $lbH5M.cellSelectionNodesBetween)(tr.selection, tr.doc, $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).FORMATTED,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $d925B.INPUT_METHOD).TOOLBAR || inputMethod === (0, $d925B.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("lbH5M", function(module, exports) {

$parcel$export(module.exports, "cellSelectionNodesBetween", () => $467b749fb75a6d67$export$bd443c1dba3019b8);
const $467b749fb75a6d67$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};

});




parcelRegister("9Xhug", function(module, exports) {

$parcel$export(module.exports, "default", () => $251906526182976c$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $lfYp8 = parcelRequire("lfYp8");

var $6iA9F = parcelRequire("6iA9F");
function $251906526182976c$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.clearFormatting).common, (0, $6iA9F.clearFormattingWithAnalytics)((0, $d925B.INPUT_METHOD).SHORTCUT, editorAnalyticsAPI), list);
    return (0, $lfYp8.keymap)(list);
}
var $251906526182976c$export$2e2bcd8739ae039 = $251906526182976c$export$e832373cff8dec22;

});

parcelRegister("4Mpmq", function(module, exports) {

$parcel$export(module.exports, "toggleEmWithAnalytics", () => $e21d843ae56a4ce0$export$fe8278eb0d365433);
$parcel$export(module.exports, "toggleStrikeWithAnalytics", () => $e21d843ae56a4ce0$export$f08ef336cb688397);
$parcel$export(module.exports, "toggleStrongWithAnalytics", () => $e21d843ae56a4ce0$export$686bc7c29753e27);
$parcel$export(module.exports, "toggleUnderlineWithAnalytics", () => $e21d843ae56a4ce0$export$bf3c86b5abdb857d);
$parcel$export(module.exports, "toggleSuperscriptWithAnalytics", () => $e21d843ae56a4ce0$export$ca1c98793b67ba6b);
$parcel$export(module.exports, "toggleSubscriptWithAnalytics", () => $e21d843ae56a4ce0$export$8d0c92ae27a193);
$parcel$export(module.exports, "toggleCodeWithAnalytics", () => $e21d843ae56a4ce0$export$2d4f5a54f840ba91);

var $d925B = parcelRequire("d925B");

var $b167b = parcelRequire("b167b");

var $fB5ro = parcelRequire("fB5ro");
const $e21d843ae56a4ce0$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(em)({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(strike)({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(strong)({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(underline)({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $e21d843ae56a4ce0$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $e21d843ae56a4ce0$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $fB5ro.nextToggleMark)(code, api)({
            tr: tr
        });
    };
const $e21d843ae56a4ce0$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $e21d843ae56a4ce0$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };

});
parcelRegister("fB5ro", function(module, exports) {

$parcel$export(module.exports, "nextToggleMark", () => $fd66d12c7d1bd84a$export$21e1076136e25038);

var $b167b = parcelRequire("b167b");

var $7T7aA = parcelRequire("7T7aA");

var $7XFGZ = parcelRequire("7XFGZ");

var $dh538 = parcelRequire("dh538");
const $fd66d12c7d1bd84a$export$21e1076136e25038 = (markType, api, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $7T7aA.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $fd66d12c7d1bd84a$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $fd66d12c7d1bd84a$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $b167b.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $fd66d12c7d1bd84a$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $b167b.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $fd66d12c7d1bd84a$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $fd66d12c7d1bd84a$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) {
        if ((0, $dh538.fg)('platform_editor_resolve_marks')) api?.base?.actions.resolveMarks(from, to, tr);
        else (0, $b167b.transformNonTextNodesToText)(from, to, tr);
    }
    /**
	 * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
	 */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};

});


parcelRegister("jbSWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c3ebae9833cf7e$export$2e2bcd8739ae039);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");
var // eslint-disable-next-line import/no-anonymous-default-export
$42c3ebae9833cf7e$export$2e2bcd8739ae039 = new (0, $1S4f7.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $7T7aA.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});

});

parcelRegister("g7Q9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $272af2f525a6adbd$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");

var $b167b = parcelRequire("b167b");

var $1S4f7 = parcelRequire("1S4f7");

var $l03WE = parcelRequire("l03WE");

var $dh538 = parcelRequire("dh538");

var $aIMBk = parcelRequire("aIMBk");
var $14sLv = parcelRequire("14sLv");
var $272af2f525a6adbd$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($272af2f525a6adbd$var$ValidAutoformatChars || {});
const $272af2f525a6adbd$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $272af2f525a6adbd$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) return null;
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') {
            if ((0, $dh538.fg)('platform_editor_resolve_marks')) api?.base?.actions?.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
            else (0, $b167b.transformNonTextNodesToText)(tr.mapping.map(start), tr.mapping.map(end), tr);
        }
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $272af2f525a6adbd$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $272af2f525a6adbd$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const combinations = $272af2f525a6adbd$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $14sLv.leafNodeReplacementCharacter)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $272af2f525a6adbd$var$ReverseRegexExp(replacedRegex);
};
const $272af2f525a6adbd$export$3312a15c47701971 = $272af2f525a6adbd$var$buildRegex("__");
const $272af2f525a6adbd$export$b2c5e5dc4b85ebff = $272af2f525a6adbd$var$buildRegex("**");
const $272af2f525a6adbd$export$5293ac529581c0f9 = $272af2f525a6adbd$var$buildRegex("_");
const $272af2f525a6adbd$export$bef0fedfe2c8027e = $272af2f525a6adbd$var$buildRegex("*");
const $272af2f525a6adbd$export$6dd2d2a62884fadf = $272af2f525a6adbd$var$buildRegex("~~");
const $272af2f525a6adbd$export$b311ac3b6caef479 = $272af2f525a6adbd$var$buildRegex("`");
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$3312a15c47701971, $272af2f525a6adbd$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$b2c5e5dc4b85ebff, $272af2f525a6adbd$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$5293ac529581c0f9, $272af2f525a6adbd$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$bef0fedfe2c8027e, $272af2f525a6adbd$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$6dd2d2a62884fadf, $272af2f525a6adbd$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const backTickRule = (0, $l03WE.createRule)($272af2f525a6adbd$export$b311ac3b6caef479, $272af2f525a6adbd$var$addMark(schema.marks.code, schema, "`", api));
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $272af2f525a6adbd$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$272af2f525a6adbd$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$272af2f525a6adbd$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$272af2f525a6adbd$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$272af2f525a6adbd$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('text-formatting', rules));
    return;
}
var $272af2f525a6adbd$export$2e2bcd8739ae039 = $272af2f525a6adbd$export$568a7ed6897c4817;

});

parcelRegister("eWbSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb356cb5191041bc$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $1S4f7 = parcelRequire("1S4f7");

var $lfYp8 = parcelRequire("lfYp8");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $4Mpmq = parcelRequire("4Mpmq");

var $b1cfE = parcelRequire("b1cfE");
function $eb356cb5191041bc$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleBold).common, (0, $4Mpmq.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleItalic).common, (0, $4Mpmq.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleCode).common, (0, $4Mpmq.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleStrikethrough).common, (0, $4Mpmq.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleSubscript).common, (0, $4Mpmq.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleSuperscript).common, (0, $4Mpmq.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleUnderline).common, (0, $4Mpmq.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $b1cfE.pluginKey).getState(view.state);
        const list = {};
        if (schema.marks.strong && !textFormattingState?.strongDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleBold).common, (0, $4Mpmq.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !textFormattingState?.emDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleItalic).common, (0, $4Mpmq.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !textFormattingState?.codeDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleCode).common, (0, $4Mpmq.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !textFormattingState?.strikeDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleStrikethrough).common, (0, $4Mpmq.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.subscriptDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleSubscript).common, (0, $4Mpmq.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.superscriptDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleSuperscript).common, (0, $4Mpmq.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !textFormattingState?.underlineDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.toggleUnderline).common, (0, $4Mpmq.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $hgeg8.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_8') ? getEnabledKeylist(view) : list;
                return (0, $lfYp8.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("b1cfE", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $09fa888fe84c9f23$export$18d4026d1ea86bb1);

var $7T7aA = parcelRequire("7T7aA");
const $09fa888fe84c9f23$export$18d4026d1ea86bb1 = new (0, $7T7aA.PluginKey)('textFormatting');

});


parcelRegister("71c8N", function(module, exports) {

$parcel$export(module.exports, "plugin", () => $87facb9c332c53bc$export$ca524d3785e2543);
// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';

var $hgeg8 = parcelRequire("hgeg8");

var $l6xRR = parcelRequire("l6xRR");

var $1S4f7 = parcelRequire("1S4f7");

var $l9G9n = parcelRequire("l9G9n");

var $5DDni = parcelRequire("5DDni");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $7kgGF = parcelRequire("7kgGF");

var $b1cfE = parcelRequire("b1cfE");
const $87facb9c332c53bc$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $7T7aA.NodeSelection)) return true;
    return false;
};
const $87facb9c332c53bc$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($87facb9c332c53bc$var$isSelectionInlineCursor(selection)) return false;
    if (type !== null || type !== undefined) return (0, $5DDni.toggleMark)(mark, {
        type: type
    })(editorState);
    return (0, $5DDni.toggleMark)(mark)(editorState);
};
const $87facb9c332c53bc$var$getTextFormattingState = (editorState, editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    if (code) {
        state.codeActive = (0, $l6xRR.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$87facb9c332c53bc$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $l6xRR.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $l6xRR.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $l6xRR.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $l6xRR.anyMarkActive)(editorState, subMark);
        state.subscriptDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptActive = (0, $l6xRR.anyMarkActive)(editorState, supMark);
        state.superscriptDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $l6xRR.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $87facb9c332c53bc$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init (_config, state) {
                return $87facb9c332c53bc$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $87facb9c332c53bc$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $l9G9n.shallowEqual)(pluginState, state)) {
                    dispatch((0, $b1cfE.pluginKey), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $b1cfE.pluginKey),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $hgeg8.moveRight).common && !event.metaKey) return $7kgGF.moveRight()(state, dispatch);
                else if (event.key === (0, $hgeg8.moveLeft).common && !event.metaKey) return $7kgGF.moveLeft()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (0, $b1cfE.pluginKey).getState(state)?.underlineDisabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_9')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $7kgGF.createInlineCodeFromTextInputWithAnalytics)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });

});
parcelRegister("7kgGF", function(module, exports) {

$parcel$export(module.exports, "moveRight", () => $571ed8f5e3913329$export$e2c874fbfec7201);
$parcel$export(module.exports, "moveLeft", () => $571ed8f5e3913329$export$108f27160c89e515);
$parcel$export(module.exports, "createInlineCodeFromTextInputWithAnalytics", () => $571ed8f5e3913329$export$7a99a2b030134bb0);

var $d925B = parcelRequire("d925B");

var $dAtrv = parcelRequire("dAtrv");

var $b167b = parcelRequire("b167b");

var $7T7aA = parcelRequire("7T7aA");

var $9pAUz = parcelRequire("9pAUz");
const $571ed8f5e3913329$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $9pAUz.markActive)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $9pAUz.markActive)(state, code.create());
            const currentPosHasCode = (0, $9pAUz.hasCode)(state, $cursor.pos);
            const nextPosHasCode = (0, $9pAUz.hasCode)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $9pAUz.hasCode)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $7T7aA.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $7T7aA.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $b167b.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).FORMATTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
            }
        })($571ed8f5e3913329$var$createInlineCodeFromTextInput(from, to, text));
    };

});


parcelRegister("7Ey9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fedcc10a2237f27$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");
var $kd4Lx = parcelRequire("kd4Lx");

var $1S4f7 = parcelRequire("1S4f7");

var $l03WE = parcelRequire("l03WE");

var $7T7aA = parcelRequire("7T7aA");

var $aIMBk = parcelRequire("aIMBk");
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $7fedcc10a2237f27$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $7T7aA.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $7fedcc10a2237f27$var$createReplacementRule(to, from) {
    return (0, $l03WE.createRule)(from, $7fedcc10a2237f27$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $7fedcc10a2237f27$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $7fedcc10a2237f27$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $7fedcc10a2237f27$var$createSingleQuotesRules() {
    return [
        // wrapped text
        // eslint-disable-next-line require-unicode-regexp
        (0, $l03WE.createRule)(/(\s|^)'(\S+.*\S+)'$/, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        $7fedcc10a2237f27$var$createReplacementRule("\u2019", /(\w+)(')(\w+)$/)
    ];
}
/**
 * Get replacement rules related to product
 */ function $7fedcc10a2237f27$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $l03WE.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $d925B.ACTION).SUBSTITUTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Trello: /(\s+|^)(trello)(\s)$/
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $7fedcc10a2237f27$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $kd4Lx.SYMBOL).ARROW_RIGHT,
        "\u2190": (0, $kd4Lx.SYMBOL).ARROW_LEFT,
        "\u2194\uFE0E": (0, $kd4Lx.SYMBOL).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $l03WE.inputRuleWithAnalytics)({
            action: (0, $d925B.ACTION).SUBSTITUTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2192": /(\s+|^)(--?>)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2190": /(\s+|^)(<--?)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2194\uFE0E": /(\s+|^)(<->?)(\s)$/
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $7fedcc10a2237f27$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $kd4Lx.PUNC).DASH,
        "\u2026": (0, $kd4Lx.PUNC).ELLIPSIS,
        "\u201D": (0, $kd4Lx.PUNC).QUOTE_DOUBLE,
        [(0, $kd4Lx.PUNC).QUOTE_SINGLE]: (0, $kd4Lx.PUNC).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $l03WE.inputRuleWithAnalytics)({
            action: (0, $d925B.ACTION).SUBSTITUTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2013": /(\s+|^)(--)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2026": /()(\.\.\.)$/
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201C": /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201D": /"$/
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $7fedcc10a2237f27$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $kd4Lx.PUNC).QUOTE_SINGLE)(rule))
    ];
}
var $7fedcc10a2237f27$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('text-formatting:smart-input', [
        ...$7fedcc10a2237f27$var$getProductRules(editorAnalyticsAPI),
        ...$7fedcc10a2237f27$var$getSymbolRules(editorAnalyticsAPI),
        ...$7fedcc10a2237f27$var$getPunctuationRules(editorAnalyticsAPI)
    ]));

});
parcelRegister("kd4Lx", function(module, exports) {

$parcel$export(module.exports, "SYMBOL", () => $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa);
$parcel$export(module.exports, "PUNC", () => $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2);
var $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});

});


parcelRegister("3Ce1I", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarTextFormalWithIntl", () => $f5dbb937cfa2eba4$export$d728f1bdde37938b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $js7oX = parcelRequire("js7oX");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $zMjD6 = parcelRequire("zMjD6");

var $b3YrF = parcelRequire("b3YrF");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $4ApR6 = parcelRequire("4ApR6");

var $fsDBA = parcelRequire("fsDBA");

var $lzHn6 = parcelRequire("lzHn6");

var $3iIn8 = parcelRequire("3iIn8");

var $3ULb3 = parcelRequire("3ULb3");

var $fkEgY = parcelRequire("fkEgY");

var $d0swK = parcelRequire("d0swK");

var $ckrNN = parcelRequire("ckrNN");
const $f5dbb937cfa2eba4$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $zMjD6.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $ckrNN.ToolbarType).FLOATING
};
const $f5dbb937cfa2eba4$var$useSharedState = (0, $574ry.sharedPluginStateHookMigratorFactory)((api)=>{
    const isInitialised = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.isInitialised');
    const formattingIsPresent = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.formattingIsPresent');
    const emActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emActive');
    const emDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emDisabled');
    const emHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emHidden');
    const codeActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeActive');
    const codeDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeDisabled');
    const codeHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeHidden');
    const underlineActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineActive');
    const underlineDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineDisabled');
    const underlineHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineHidden');
    const strikeActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeActive');
    const strikeDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeDisabled');
    const strikeHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeHidden');
    const strongActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongActive');
    const strongDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongDisabled');
    const strongHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongHidden');
    const superscriptActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptActive');
    const superscriptDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptDisabled');
    const superscriptHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptHidden');
    const subscriptActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptActive');
    const subscriptDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptDisabled');
    const subscriptHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptHidden');
    return {
        isInitialised: Boolean(isInitialised),
        formattingIsPresent: formattingIsPresent,
        emActive: emActive,
        emDisabled: emDisabled,
        emHidden: emHidden,
        codeActive: codeActive,
        codeDisabled: codeDisabled,
        codeHidden: codeHidden,
        underlineActive: underlineActive,
        underlineDisabled: underlineDisabled,
        underlineHidden: underlineHidden,
        strikeActive: strikeActive,
        strikeDisabled: strikeDisabled,
        strikeHidden: strikeHidden,
        strongActive: strongActive,
        strongDisabled: strongDisabled,
        strongHidden: strongHidden,
        superscriptActive: superscriptActive,
        superscriptDisabled: superscriptDisabled,
        superscriptHidden: superscriptHidden,
        subscriptActive: subscriptActive,
        subscriptDisabled: subscriptDisabled,
        subscriptHidden: subscriptHidden
    };
}, (api)=>{
    const { textFormattingState: textFormattingState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'textFormatting'
    ]);
    return {
        isInitialised: Boolean(textFormattingState?.isInitialised),
        formattingIsPresent: textFormattingState?.formattingIsPresent,
        emActive: textFormattingState?.emActive,
        emDisabled: textFormattingState?.emDisabled,
        emHidden: textFormattingState?.emHidden,
        codeActive: textFormattingState?.codeActive,
        codeDisabled: textFormattingState?.codeDisabled,
        codeHidden: textFormattingState?.codeHidden,
        underlineActive: textFormattingState?.underlineActive,
        underlineDisabled: textFormattingState?.underlineDisabled,
        underlineHidden: textFormattingState?.underlineHidden,
        strikeActive: textFormattingState?.strikeActive,
        strikeDisabled: textFormattingState?.strikeDisabled,
        strikeHidden: textFormattingState?.strikeHidden,
        strongActive: textFormattingState?.strongActive,
        strongDisabled: textFormattingState?.strongDisabled,
        strongHidden: textFormattingState?.strongHidden,
        superscriptActive: textFormattingState?.superscriptActive,
        superscriptDisabled: textFormattingState?.superscriptDisabled,
        superscriptHidden: textFormattingState?.superscriptHidden,
        subscriptActive: textFormattingState?.subscriptActive,
        subscriptDisabled: textFormattingState?.subscriptDisabled,
        subscriptHidden: textFormattingState?.subscriptHidden
    };
});
const $f5dbb937cfa2eba4$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = $f5dbb937cfa2eba4$var$useSharedState(api);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    let hasMultiplePartsWithFormattingSelected;
    let commonActiveMarks = [];
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_7')) {
        const { selection: selection } = editorView.state;
        const { from: from, to: to } = selection;
        const selectedContent = selection instanceof (0, $7T7aA.TextSelection) ? editorView.state.doc.slice(from, to).content.content.slice() : undefined;
        hasMultiplePartsWithFormattingSelected = (0, $lzHn6.hasMultiplePartsWithFormattingInSelection)({
            selectedContent: selectedContent
        });
        if ((0, $dh538.fg)('platform_editor_controls_patch_10')) commonActiveMarks = (0, $lzHn6.getCommonActiveMarks)({
            selectedContent: selectedContent
        });
    }
    const defaultIcons = (0, $3ULb3.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType,
        hasMultiplePartsWithFormattingSelected: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_10') ? hasMultiplePartsWithFormattingSelected : undefined,
        commonActiveMarks: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_10') ? commonActiveMarks : undefined
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $fkEgY.useIconList)({
        icons: defaultIcons,
        iconTypeList: (0, $4ApR6.ToolbarButtonsStrong),
        shouldUnselect: hasMultiplePartsWithFormattingSelected
    });
    const clearIcon = (0, $3iIn8.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $gwFzn.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $d0swK.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fsDBA.FormattingTextDropdownMenu), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : $f5dbb937cfa2eba4$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected
    }));
};
const $f5dbb937cfa2eba4$export$d728f1bdde37938b = (0, $js7oX.default)($f5dbb937cfa2eba4$var$FloatingToolbarTextFormat);

});
parcelRegister("4ApR6", function(module, exports) {

$parcel$export(module.exports, "ToolbarButtonsStrongItalic", () => $387041f5cfaa6663$export$37a675a4731536c);
$parcel$export(module.exports, "ToolbarButtonsStrong", () => $387041f5cfaa6663$export$9930ae1c7f6b53f3);
$parcel$export(module.exports, "ToolbarButtonsStrongItalicUnderline", () => $387041f5cfaa6663$export$def34bf0ee813055);
$parcel$export(module.exports, "ButtonsMenuMinimal", () => $387041f5cfaa6663$export$5789feaf6941ee12);
$parcel$export(module.exports, "ButtonsMenuCompact", () => $387041f5cfaa6663$export$f40ebaa61bfc4d53);
$parcel$export(module.exports, "ButtonsMenuSpacious", () => $387041f5cfaa6663$export$b1ac64c82cac61ce);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarMinimal", () => $387041f5cfaa6663$export$13589e95a4a6fb40);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarCompact", () => $387041f5cfaa6663$export$fdd1bbcb63018330);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarSpacious", () => $387041f5cfaa6663$export$861ad8d05e95bc1e);
$parcel$export(module.exports, "ResponsiveCustomMenuMinimal", () => $387041f5cfaa6663$export$1b53a931a2dd9e07);
$parcel$export(module.exports, "ResponsiveCustomMenuCompact", () => $387041f5cfaa6663$export$53d57ab9be604153);
$parcel$export(module.exports, "ResponsiveCustomMenuSpacious", () => $387041f5cfaa6663$export$77ad87491c5fbf88);

var $zMjD6 = parcelRequire("zMjD6");

var $ckrNN = parcelRequire("ckrNN");
const $387041f5cfaa6663$export$37a675a4731536c = [
    (0, $ckrNN.IconTypes).strong,
    (0, $ckrNN.IconTypes).em
];
const $387041f5cfaa6663$export$9930ae1c7f6b53f3 = [
    (0, $ckrNN.IconTypes).strong
];
const $387041f5cfaa6663$export$def34bf0ee813055 = [
    (0, $ckrNN.IconTypes).strong,
    (0, $ckrNN.IconTypes).em,
    (0, $ckrNN.IconTypes).underline
];
const $387041f5cfaa6663$export$5789feaf6941ee12 = [
    (0, $ckrNN.IconTypes).em,
    (0, $ckrNN.IconTypes).underline,
    (0, $ckrNN.IconTypes).strike,
    (0, $ckrNN.IconTypes).code,
    (0, $ckrNN.IconTypes).subscript,
    (0, $ckrNN.IconTypes).superscript
];
const $387041f5cfaa6663$export$f40ebaa61bfc4d53 = [
    (0, $ckrNN.IconTypes).underline,
    (0, $ckrNN.IconTypes).strike,
    (0, $ckrNN.IconTypes).code,
    (0, $ckrNN.IconTypes).subscript,
    (0, $ckrNN.IconTypes).superscript
];
const $387041f5cfaa6663$export$b1ac64c82cac61ce = [
    (0, $ckrNN.IconTypes).strike,
    (0, $ckrNN.IconTypes).code,
    (0, $ckrNN.IconTypes).subscript,
    (0, $ckrNN.IconTypes).superscript
];
const $387041f5cfaa6663$export$13589e95a4a6fb40 = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $zMjD6.ToolbarSize).M]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $zMjD6.ToolbarSize).S]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $zMjD6.ToolbarSize).XXXS]: []
};
const $387041f5cfaa6663$export$fdd1bbcb63018330 = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).M]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).S]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).XXXS]: []
};
const $387041f5cfaa6663$export$861ad8d05e95bc1e = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $zMjD6.ToolbarSize).M]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).S]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $zMjD6.ToolbarSize).XXXS]: $387041f5cfaa6663$export$9930ae1c7f6b53f3
};
const $387041f5cfaa6663$export$1b53a931a2dd9e07 = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $zMjD6.ToolbarSize).M]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $zMjD6.ToolbarSize).S]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $zMjD6.ToolbarSize).XXXS]: [
        (0, $ckrNN.IconTypes).strong,
        (0, $ckrNN.IconTypes).em,
        ...$387041f5cfaa6663$export$5789feaf6941ee12
    ]
};
const $387041f5cfaa6663$export$53d57ab9be604153 = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $zMjD6.ToolbarSize).M]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $zMjD6.ToolbarSize).S]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $zMjD6.ToolbarSize).XXXS]: [
        (0, $ckrNN.IconTypes).strong,
        (0, $ckrNN.IconTypes).em,
        ...$387041f5cfaa6663$export$f40ebaa61bfc4d53
    ]
};
const $387041f5cfaa6663$export$77ad87491c5fbf88 = {
    [(0, $zMjD6.ToolbarSize).XXL]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $zMjD6.ToolbarSize).XL]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $zMjD6.ToolbarSize).L]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $zMjD6.ToolbarSize).M]: [
        (0, $ckrNN.IconTypes).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ],
    [(0, $zMjD6.ToolbarSize).S]: [
        (0, $ckrNN.IconTypes).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ],
    [(0, $zMjD6.ToolbarSize).XXXS]: [
        (0, $ckrNN.IconTypes).em,
        (0, $ckrNN.IconTypes).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ]
};

});
parcelRegister("ckrNN", function(module, exports) {

$parcel$export(module.exports, "IconTypes", () => $2cca58939a01b863$export$f84ca76848e3ed34);
$parcel$export(module.exports, "ToolbarType", () => $2cca58939a01b863$export$a5d11b3163e4b1a5);
var $2cca58939a01b863$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $2cca58939a01b863$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});


parcelRegister("fsDBA", function(module, exports) {

$parcel$export(module.exports, "FormattingTextDropdownMenu", () => $e664dcb48a74cd94$export$52e9a2bbe5d185e8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2zaaI = parcelRequire("2zaaI");

var $h4TOP = parcelRequire("h4TOP");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $azBLi = parcelRequire("azBLi");

var $kRROq = parcelRequire("kRROq");

var $ec8vd = parcelRequire("ec8vd");
const $e664dcb48a74cd94$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected, isDisabled: isDisabled })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $kRROq.useMenuState)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $gwFzn.useState)(false);
    const onItemActivated = (0, $gwFzn.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_4') ? items[0].items[0]?.elemBefore : undefined;
    const defaultIconName = items[0].items[0]?.value.name;
    let iconBefore;
    let activeIconName = defaultIconName;
    if (hasMultiplePartsWithFormattingSelected && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_7')) iconBefore = defaultIcon;
    else {
        iconBefore = activeItem ? activeItem?.elemBefore : defaultIcon;
        activeIconName = activeItem?.value.name || defaultIconName;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $aFUXX.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        section: {
            hasSeparator: true
        },
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        },
        children: hasMoreButton ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ec8vd.MoreButton), {
            isSelected: isMenuOpen || hasFormattingActive,
            label: moreButtonLabel,
            isReducedSpacing: isReducedSpacing,
            isDisabled: false,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            "aria-expanded": isMenuOpen
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $azBLi.DropdownToolbarButton), {
            isReducedSpacing: isReducedSpacing,
            isDisabled: Boolean(isDisabled),
            isSelected: isMenuOpen,
            label: intl.formatMessage((0, $2zaaI.toolbarMessages).textFormat),
            "aria-expanded": isMenuOpen,
            "aria-haspopup": true,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            toolbarType: toolbarType,
            iconBefore: iconBefore,
            activeIconName: activeIconName
        })
    });
});

});
parcelRegister("azBLi", function(module, exports) {

$parcel$export(module.exports, "DropdownToolbarButton", () => $847dc66460b82017$export$7c43b97d70f40057);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $cORDs = parcelRequire("cORDs");
var $iMS6j = parcelRequire("iMS6j");

var $a4eZN = parcelRequire("a4eZN");

var $7kzZ3 = parcelRequire("7kzZ3");

var $85Ln8 = parcelRequire("85Ln8");

var $dh538 = parcelRequire("dh538");

var $ckrNN = parcelRequire("ckrNN");
const $847dc66460b82017$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $ckrNN.ToolbarType).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $cORDs.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $dh538.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cORDs.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cORDs.triggerWrapperStyles),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85Ln8))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
            css: (0, $iMS6j.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px",
            size: "small"
        })))
    });
};

});

parcelRegister("kRROq", function(module, exports) {

$parcel$export(module.exports, "useMenuState", () => $13c41b8af588762d$export$8091e3849c182a6);

var $gwFzn = parcelRequire("gwFzn");
const $13c41b8af588762d$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $gwFzn.useState)(false);
    const toggleMenu = (0, $gwFzn.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $gwFzn.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};

});

parcelRegister("ec8vd", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $140891e9e23b787e$export$7f94856880993f27);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $cORDs = parcelRequire("cORDs");

var $a4eZN = parcelRequire("a4eZN");

var $2wS8M = parcelRequire("2wS8M");

var $dh538 = parcelRequire("dh538");
const $140891e9e23b787e$var$MoreIconStyle = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)"
});
const $140891e9e23b787e$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $a4eZN.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-prefix -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: (0, $dh538.fg)('platform-visual-refresh-icons') ? $140891e9e23b787e$var$MoreIconStyle : (0, $cORDs.triggerWrapperStyles)
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wS8M))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            size: "small"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});

});


parcelRegister("lzHn6", function(module, exports) {

$parcel$export(module.exports, "hasMultiplePartsWithFormattingInSelection", () => $690ac48b81615ea8$export$93dfd4ecb1fdf6d4);
$parcel$export(module.exports, "getCommonActiveMarks", () => $690ac48b81615ea8$export$4c389142e2cf768e);

var $dh538 = parcelRequire("dh538");

var $ckrNN = parcelRequire("ckrNN");
const $690ac48b81615ea8$var$isMarkInIconTypes = (node)=>node.marks.some((mark)=>Object.values((0, $ckrNN.IconTypes)).includes(mark.type.name));
const $690ac48b81615ea8$export$93dfd4ecb1fdf6d4 = ({ selectedContent: selectedContent })=>{
    if (!selectedContent) return false;
    if ((0, $dh538.fg)('platform_editor_controls_patch_8')) {
        // Check if there are multiple parts with formatting or if only one part has formatting and the rest have none
        const contentWithMarks = selectedContent.filter((child)=>$690ac48b81615ea8$var$isMarkInIconTypes(child));
        const hasFormatting = contentWithMarks.length > 0;
        const allPartsHaveFormatting = contentWithMarks.length === selectedContent.length;
        return hasFormatting && (!allPartsHaveFormatting || contentWithMarks.length > 1);
    }
    const marks = selectedContent.map((child)=>$690ac48b81615ea8$var$isMarkInIconTypes(child) ? child.marks : undefined).filter(Boolean);
    return marks.length > 1;
};
const $690ac48b81615ea8$export$4c389142e2cf768e = ({ selectedContent: selectedContent })=>{
    if (!selectedContent || selectedContent.length === 0) return [];
    // filter out fragment node contains only spaces
    const filteredSelectedContent = selectedContent.filter((child)=>child.text?.trim() !== '');
    // find the active mark type in first part
    const firstPartMarks = selectedContent[0].marks.map((mark)=>mark.type.name);
    // check if all other parts have the same mark type as the first part and return the common mark types
    const commonMarkTypes = firstPartMarks.filter((mark)=>filteredSelectedContent.every((child)=>child.marks.some((m)=>m.type.name === mark)));
    return commonMarkTypes;
};

});

parcelRegister("3iIn8", function(module, exports) {

$parcel$export(module.exports, "useClearIcon", () => $1996c9b6f6bd9ee0$export$4ff17fae4b9914b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $hgeg8 = parcelRequire("hgeg8");

var $2zaaI = parcelRequire("2zaaI");

var $6f5RK = parcelRequire("6f5RK");

var $iV7dk = parcelRequire("iV7dk");

var $iu6m9 = parcelRequire("iu6m9");

var $6iA9F = parcelRequire("6iA9F");

var $eLQ7o = parcelRequire("eLQ7o");
const $1996c9b6f6bd9ee0$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $2zaaI.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $gwFzn.useCallback)((state, dispatch)=>(0, $6iA9F.clearFormattingWithAnalytics)((0, $eLQ7o.getInputMethod)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $hgeg8.clearFormatting) ? (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};

});
parcelRegister("eLQ7o", function(module, exports) {

$parcel$export(module.exports, "getInputMethod", () => $a5628beebd6ca577$export$8213a6fbfa466e73);

var $d925B = parcelRequire("d925B");

var $ckrNN = parcelRequire("ckrNN");
const $a5628beebd6ca577$export$ec2f5afcaf7ee094 = {
    [(0, $ckrNN.ToolbarType).PRIMARY]: (0, $d925B.INPUT_METHOD).TOOLBAR,
    [(0, $ckrNN.ToolbarType).FLOATING]: (0, $d925B.INPUT_METHOD).FLOATING_TB
};
const $a5628beebd6ca577$export$8213a6fbfa466e73 = (toolbarType)=>$a5628beebd6ca577$export$ec2f5afcaf7ee094[toolbarType];

});


parcelRegister("3ULb3", function(module, exports) {

$parcel$export(module.exports, "useFormattingIcons", () => $74f32cf3e14ca459$export$6f298ec13df828);
$parcel$export(module.exports, "useHasFormattingActived", () => $74f32cf3e14ca459$export$cb0a2ed6e982a08f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $8TW6I = parcelRequire("8TW6I");

var $hgeg8 = parcelRequire("hgeg8");

var $2zaaI = parcelRequire("2zaaI");

var $gmyMu = parcelRequire("gmyMu");

var $6f5RK = parcelRequire("6f5RK");

var $f4Rpb = parcelRequire("f4Rpb");

var $l6sV5 = parcelRequire("l6sV5");

var $85Ln8 = parcelRequire("85Ln8");

var $jHpAD = parcelRequire("jHpAD");

var $4E5My = parcelRequire("4E5My");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $4Mpmq = parcelRequire("4Mpmq");

var $cv11A = parcelRequire("cv11A");

var $eLQ7o = parcelRequire("eLQ7o");

var $ckrNN = parcelRequire("ckrNN");
const $74f32cf3e14ca459$var$withInputMethod = (toolbarType, func)=>(0, $gmyMu.editorCommandToPMCommand)(func((0, $eLQ7o.getInputMethod)(toolbarType)));
const $74f32cf3e14ca459$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleStrongWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).bold,
            tooltipKeymap: (0, $hgeg8.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6sV5))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleEmWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).italic,
            tooltipKeymap: (0, $hgeg8.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85Ln8))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).underline,
            tooltipKeymap: (0, $hgeg8.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4E5My))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleStrikeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).strike,
            tooltipKeymap: (0, $hgeg8.toggleStrikethrough)
        },
        code: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleCodeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).code,
            tooltipKeymap: (0, $hgeg8.toggleCode)
        },
        subscript: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).subscript,
            tooltipKeymap: (0, $hgeg8.toggleSubscript)
        },
        superscript: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $4Mpmq.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).superscript,
            tooltipKeymap: (0, $hgeg8.toggleSuperscript)
        }
    });
const $74f32cf3e14ca459$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6sV5))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85Ln8))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4E5My))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHpAD))), {
            label: ""
        })
    },
    code: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4Rpb))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cv11A.Subscript), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cv11A.Superscript), null)
    }
};
const $74f32cf3e14ca459$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $74f32cf3e14ca459$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $74f32cf3e14ca459$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $hgeg8.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: (0, $6f5RK.shortcutStyle)
        }, (0, $hgeg8.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $hgeg8.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $hgeg8.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $74f32cf3e14ca459$var$IconsMarkSchema = {
    [(0, $ckrNN.IconTypes).strong]: 'strong',
    [(0, $ckrNN.IconTypes).em]: 'em',
    [(0, $ckrNN.IconTypes).strike]: 'strike',
    [(0, $ckrNN.IconTypes).code]: 'code',
    [(0, $ckrNN.IconTypes).underline]: 'underline',
    [(0, $ckrNN.IconTypes).superscript]: 'subsup',
    [(0, $ckrNN.IconTypes).subscript]: 'subsup'
};
const $74f32cf3e14ca459$var$buildMenuIconState = (iconMark, hasMultiplePartsWithFormattingSelected, commonActiveMarks)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState?.isInitialised);
        const markSchema = $74f32cf3e14ca459$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = hasMultiplePartsWithFormattingSelected && !commonActiveMarks?.includes(iconMark) && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_10') ? false : textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $74f32cf3e14ca459$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks)=>{
    const getState = $74f32cf3e14ca459$var$buildMenuIconState(iconMark, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $gwFzn.useMemo)(()=>$74f32cf3e14ca459$var$getIcon({
                iconType: (0, $ckrNN.IconTypes)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $gwFzn.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $74f32cf3e14ca459$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected, commonActiveMarks: commonActiveMarks })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected,
        commonActiveMarks: commonActiveMarks
    };
    const buildStrongIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).strong, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildEmIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).em, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildUnderlineIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).underline, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildStrikeIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).strike, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildCodeIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).code, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildSubscriptIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).subscript, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildSuperscriptIcon = $74f32cf3e14ca459$var$buildIcon((0, $ckrNN.IconTypes).superscript, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $gwFzn.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $74f32cf3e14ca459$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $gwFzn.useMemo)(()=>{
        if (!textFormattingState?.isInitialised) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};

});
parcelRegister("cv11A", function(module, exports) {

$parcel$export(module.exports, "Subscript", () => $c2effb35c1d6195c$export$54eb3b8088f84d2b);
$parcel$export(module.exports, "Superscript", () => $c2effb35c1d6195c$export$a4eac561e2e9d419);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $c2effb35c1d6195c$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        children: children
    });
const $c2effb35c1d6195c$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($c2effb35c1d6195c$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
                fill: "currentColor"
            })
        })
    });
const $c2effb35c1d6195c$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($c2effb35c1d6195c$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("fkEgY", function(module, exports) {

$parcel$export(module.exports, "useIconList", () => $79aeb6914e29e11a$export$894adbec036a07c6);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $79aeb6914e29e11a$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList, shouldUnselect: shouldUnselect })=>{
    return (0, $gwFzn.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            shouldUnselect && icon.isActive && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_7') && !(0, $dh538.fg)('platform_editor_controls_patch_10')) icon.isActive = false;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        shouldUnselect,
        iconTypeList
    ]);
};

});

parcelRegister("d0swK", function(module, exports) {

$parcel$export(module.exports, "SingleToolbarButtons", () => $bd700498505ff390$export$e3e9702c9c21585);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $cORDs = parcelRequire("cORDs");

var $a4eZN = parcelRequire("a4eZN");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $bd700498505ff390$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected })=>{
    const onClick = (0, $gwFzn.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $dh538.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyleBeforeVisualRefresh)
    }, items.map((item)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $a4eZN.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            hasMultiplePartsWithFormattingSelected && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_7') && !(0, $dh538.fg)('platform_editor_controls_patch_10') ? false : item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            hasMultiplePartsWithFormattingSelected && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_7') && !(0, $dh538.fg)('platform_editor_controls_patch_10') ? false : item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});

});


parcelRegister("1Ypz8", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $b0a680815b4ae49f$export$94516d5cccf573e3);
$parcel$export(module.exports, "PrimaryToolbarComponentMemoized", () => $b0a680815b4ae49f$export$aa7d892cb2b41646);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $b3YrF = parcelRequire("b3YrF");

var $awoSS = parcelRequire("awoSS");

var $ckrNN = parcelRequire("ckrNN");
const $b0a680815b4ae49f$var$useSharedState = (0, $574ry.sharedPluginStateHookMigratorFactory)((api)=>{
    const isInitialised = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.isInitialised');
    const formattingIsPresent = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.formattingIsPresent');
    const emActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emActive');
    const emDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emDisabled');
    const emHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.emHidden');
    const codeActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeActive');
    const codeDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeDisabled');
    const codeHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.codeHidden');
    const underlineActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineActive');
    const underlineDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineDisabled');
    const underlineHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.underlineHidden');
    const strikeActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeActive');
    const strikeDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeDisabled');
    const strikeHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strikeHidden');
    const strongActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongActive');
    const strongDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongDisabled');
    const strongHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.strongHidden');
    const superscriptActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptActive');
    const superscriptDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptDisabled');
    const superscriptHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.superscriptHidden');
    const subscriptActive = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptActive');
    const subscriptDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptDisabled');
    const subscriptHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'textFormatting.subscriptHidden');
    return {
        isInitialised: Boolean(isInitialised),
        formattingIsPresent: formattingIsPresent,
        emActive: emActive,
        emDisabled: emDisabled,
        emHidden: emHidden,
        codeActive: codeActive,
        codeDisabled: codeDisabled,
        codeHidden: codeHidden,
        underlineActive: underlineActive,
        underlineDisabled: underlineDisabled,
        underlineHidden: underlineHidden,
        strikeActive: strikeActive,
        strikeDisabled: strikeDisabled,
        strikeHidden: strikeHidden,
        strongActive: strongActive,
        strongDisabled: strongDisabled,
        strongHidden: strongHidden,
        superscriptActive: superscriptActive,
        superscriptDisabled: superscriptDisabled,
        superscriptHidden: superscriptHidden,
        subscriptActive: subscriptActive,
        subscriptDisabled: subscriptDisabled,
        subscriptHidden: subscriptHidden
    };
}, (api)=>{
    const { textFormattingState: textFormattingState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'textFormatting'
    ]);
    return {
        isInitialised: Boolean(textFormattingState?.isInitialised),
        formattingIsPresent: textFormattingState?.formattingIsPresent,
        emActive: textFormattingState?.emActive,
        emDisabled: textFormattingState?.emDisabled,
        emHidden: textFormattingState?.emHidden,
        codeActive: textFormattingState?.codeActive,
        codeDisabled: textFormattingState?.codeDisabled,
        codeHidden: textFormattingState?.codeHidden,
        underlineActive: textFormattingState?.underlineActive,
        underlineDisabled: textFormattingState?.underlineDisabled,
        underlineHidden: textFormattingState?.underlineHidden,
        strikeActive: textFormattingState?.strikeActive,
        strikeDisabled: textFormattingState?.strikeDisabled,
        strikeHidden: textFormattingState?.strikeHidden,
        strongActive: textFormattingState?.strongActive,
        strongDisabled: textFormattingState?.strongDisabled,
        strongHidden: textFormattingState?.strongHidden,
        superscriptActive: textFormattingState?.superscriptActive,
        superscriptDisabled: textFormattingState?.superscriptDisabled,
        superscriptHidden: textFormattingState?.superscriptHidden,
        subscriptActive: textFormattingState?.subscriptActive,
        subscriptDisabled: textFormattingState?.subscriptDisabled,
        subscriptHidden: textFormattingState?.subscriptHidden
    };
});
function $b0a680815b4ae49f$export$94516d5cccf573e3({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar }) {
    const textFormattingState = $b0a680815b4ae49f$var$useSharedState(api);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $awoSS.default), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api,
        toolbarType: (0, $ckrNN.ToolbarType).PRIMARY
    });
}
const $b0a680815b4ae49f$export$aa7d892cb2b41646 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($b0a680815b4ae49f$export$94516d5cccf573e3);

});
parcelRegister("awoSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9359b424429db47$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $js7oX = parcelRequire("js7oX");

var $7541v = parcelRequire("7541v");

var $2zaaI = parcelRequire("2zaaI");

var $cORDs = parcelRequire("cORDs");

var $cftLn = parcelRequire("cftLn");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $9pAUz = parcelRequire("9pAUz");

var $fsDBA = parcelRequire("fsDBA");

var $3iIn8 = parcelRequire("3iIn8");

var $3ULb3 = parcelRequire("3ULb3");

var $3T2op = parcelRequire("3T2op");

var $ec8vd = parcelRequire("ec8vd");

var $d0swK = parcelRequire("d0swK");
const $c9359b424429db47$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $gwFzn.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $3ULb3.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $3iIn8.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $3T2op.useResponsiveIconTypeMenu)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $3ULb3.useHasFormattingActived)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $3T2op.useResponsiveToolbarButtons)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).subscriptOffSuperscriptOn);
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $7541v.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $9pAUz.isArrayContainsContent)(activeItems, 'Subscript') && (0, $9pAUz.isArrayContainsContent)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $9pAUz.isArrayContainsContent)(activeItems, 'Superscript') && (0, $9pAUz.isArrayContainsContent)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $9pAUz.compareItemsArrays)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $9pAUz.compareItemsArrays)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $gwFzn.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $2zaaI.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $2zaaI.toolbarMessages).textFormatting);
    (0, $gwFzn.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $dh538.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cftLn.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $d0swK.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $cORDs.wrapperStyle)
    }, isToolbarDisabled && !((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_10')) ? /*#__PURE__*/ (0, $3jLHL.jsx)("div", null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ec8vd.MoreButton), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fsDBA.FormattingTextDropdownMenu), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_4') ? false : true,
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_controls_patch_10') ? isToolbarDisabled : false
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $cORDs.separatorStyles)
    })));
};
const $c9359b424429db47$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)($c9359b424429db47$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
var $c9359b424429db47$export$2e2bcd8739ae039 = (0, $js7oX.default)($c9359b424429db47$var$Toolbar);

});
parcelRegister("3T2op", function(module, exports) {

$parcel$export(module.exports, "useResponsiveIconTypeMenu", () => $0ebb7f33b77e48eb$export$110e6c3d6580196f);
$parcel$export(module.exports, "useResponsiveToolbarButtons", () => $0ebb7f33b77e48eb$export$efa5449fdb315092);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $dZ8uq = parcelRequire("dZ8uq");

var $4ApR6 = parcelRequire("4ApR6");

var $fkEgY = parcelRequire("fkEgY");
const $0ebb7f33b77e48eb$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomButtonToolbar = (0, $4ApR6.ResponsiveCustomButtonToolbarCompact);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) {
        if ((0, $dh538.fg)('platform_editor_controls_patch_13')) ResponsiveCustomButtonToolbar = (0, $4ApR6.ResponsiveCustomButtonToolbarMinimal);
        else ResponsiveCustomButtonToolbar = !(0, $dh538.fg)('platform_editor_controls_patch_4') ? (0, $4ApR6.ResponsiveCustomButtonToolbarSpacious) : (0, $4ApR6.ResponsiveCustomButtonToolbarCompact);
    }
    const iconTypeList = (0, $gwFzn.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) {
        if ((0, $dh538.fg)('platform_editor_controls_patch_13')) return 0, $4ApR6.ToolbarButtonsStrong;
        else return !(0, $dh538.fg)('platform_editor_controls_patch_4') ? (0, $4ApR6.ToolbarButtonsStrongItalicUnderline) : (0, $4ApR6.ToolbarButtonsStrongItalic);
    } else return 0, $4ApR6.ToolbarButtonsStrongItalic;
};
const $0ebb7f33b77e48eb$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomMenu = (0, $4ApR6.ResponsiveCustomMenuCompact);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) {
        if ((0, $dh538.fg)('platform_editor_controls_patch_13')) ResponsiveCustomMenu = (0, $4ApR6.ResponsiveCustomMenuMinimal);
        else ResponsiveCustomMenu = !(0, $dh538.fg)('platform_editor_controls_patch_4') ? (0, $4ApR6.ResponsiveCustomMenuSpacious) : (0, $4ApR6.ResponsiveCustomMenuCompact);
    }
    const iconTypeList = (0, $gwFzn.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) {
        if ((0, $dh538.fg)('platform_editor_controls_patch_13')) return 0, $4ApR6.ButtonsMenuMinimal;
        else return !(0, $dh538.fg)('platform_editor_controls_patch_4') ? (0, $4ApR6.ButtonsMenuSpacious) : (0, $4ApR6.ButtonsMenuCompact);
    } else return 0, $4ApR6.ToolbarButtonsStrongItalic;
};
const $0ebb7f33b77e48eb$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $0ebb7f33b77e48eb$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $fkEgY.useIconList)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};

});




parcelRegister("6borH", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => $3e1d186d16c7f25c$export$e488d499f3ae3f86);

var $5BoIc = parcelRequire("5BoIc");
const $3e1d186d16c7f25c$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $5BoIc.createPlugin)(dispatch, api, onSave)
                }
            ];
        }
    });

});
parcelRegister("5BoIc", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a01d6a19cb9afa72$export$ae829ec7b2625219);

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $lWghV = parcelRequire("lWghV");

var $lfYp8 = parcelRequire("lfYp8");
function $a01d6a19cb9afa72$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $lfYp8.keymap)({
        [`${(0, $hgeg8.submit).common}`]: (state, _dispatch, editorView)=>{
            const mediaState = api?.media?.sharedState?.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $lWghV.analyticsEventKey), $a01d6a19cb9afa72$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $a01d6a19cb9afa72$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $d925B.ACTION).STOPPED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        }
    });

});


parcelRegister("kuh1P", function(module, exports) {

$parcel$export(module.exports, "getDomRefFromSelection", () => $7e8a46109aa777b7$export$49d74ed2464a12b9);

var $gWR1e = parcelRequire("gWR1e");

var $d925B = parcelRequire("d925B");
const $7e8a46109aa777b7$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $gWR1e.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};

});

parcelRegister("hcboS", function(module, exports) {

$parcel$export(module.exports, "emojiPlugin", () => $8d1c5078b4947753$export$d1221bd3f80501e0);
$parcel$export(module.exports, "emojiPluginKey", () => $8d1c5078b4947753$export$e3ef5170578bd8ba);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");

var $hgeg8 = parcelRequire("hgeg8");

var $ahUGI = parcelRequire("ahUGI");
var $4HWgE = parcelRequire("4HWgE");

var $3pLGZ = parcelRequire("3pLGZ");

var $bT1qC = parcelRequire("bT1qC");

var $1S4f7 = parcelRequire("1S4f7");

var $lOELb = parcelRequire("lOELb");

var $lNDSG = parcelRequire("lNDSG");

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $kVNt7 = parcelRequire("kVNt7");
var $lGf1F = parcelRequire("lGf1F");
var $injKz = parcelRequire("injKz");
var $aGYoD = parcelRequire("aGYoD");

var $1yB28 = parcelRequire("1yB28");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $kQc80 = parcelRequire("kQc80");

var $f7ugX = parcelRequire("f7ugX");

var $j0XxS = parcelRequire("j0XxS");

var $lhIns = parcelRequire("lhIns");

var $cKEEj = parcelRequire("cKEEj");

var $cTFYB = parcelRequire("cTFYB");

var $aFWfo = parcelRequire("aFWfo");
const $8d1c5078b4947753$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kVNt7.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $8d1c5078b4947753$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $8d1c5078b4947753$var$memoizedToItem = $8d1c5078b4947753$export$fc10aeed3a532e2a($8d1c5078b4947753$export$144d1b98bacb98cc);
const $8d1c5078b4947753$export$9f7de4293d27f3aa = 50;
const $8d1c5078b4947753$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $8d1c5078b4947753$var$TRIGGER = ':';
function $8d1c5078b4947753$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $8d1c5078b4947753$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).EMOJI,
        trigger: $8d1c5078b4947753$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $8d1c5078b4947753$export$44feec10c1b38749(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$8d1c5078b4947753$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($8d1c5078b4947753$var$TRIGGER.concat(query), {
                    limit: $8d1c5078b4947753$export$9f7de4293d27f3aa,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $aGYoD.SearchSort).UsageFrequency : (0, $aGYoD.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $8d1c5078b4947753$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $8d1c5078b4947753$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $injKz.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $injKz.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            let fragment;
            if ((0, $dh538.fg)('editor_inline_comments_paste_insert_nodes')) fragment = (0, $kQc80.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            else {
                const { id: id = '', fallback: fallback, shortName: shortName } = item.emoji;
                const text = fallback || shortName;
                const emojiNode = state.schema.nodes.emoji.createChecked({
                    shortName: shortName,
                    id: id,
                    text: text
                });
                const space = state.schema.text(' ');
                fragment = (0, $kviC1.Fragment).from([
                    emojiNode,
                    space
                ]);
            }
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j0XxS.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $gwFzn.useEffect)(()=>{
                $8d1c5078b4947753$var$delayUntilIdle(()=>{
                    (0, $lGf1F.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $8d1c5078b4947753$export$8954f41a1af29eaf(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $cTFYB.inputRulePlugin)(schema, api?.analytics?.actions, api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $cKEEj.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$8d1c5078b4947753$export$7aee320da5ebec42(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $kQc80.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control')) return null;
            if (!(0, $iu6m9.editorExperiment)('platform_editor_controls_performance_fixes', true)) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aFWfo.InlineEmojiPopupOld), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement,
                onClose: ()=>editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr))
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aFWfo.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3pLGZ.IconEmoji), {}),
                        action (insert) {
                            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $cKEEj.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $8d1c5078b4947753$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $cKEEj.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $8d1c5078b4947753$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $8d1c5078b4947753$var$logRateWarning = ()=>{};
const $8d1c5078b4947753$export$7aee320da5ebec42 = $8d1c5078b4947753$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $cKEEj.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $8d1c5078b4947753$var$logRateWarning);
const $8d1c5078b4947753$export$1572b3eade6662f9 = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $8d1c5078b4947753$export$7aee320da5ebec42(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $8d1c5078b4947753$export$e3ef5170578bd8ba = new (0, $7T7aA.PluginKey)('emojiPlugin');
function $8d1c5078b4947753$export$44feec10c1b38749(state) {
    return $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state) || {};
}
function $8d1c5078b4947753$export$8954f41a1af29eaf(pmPluginFactoryParams, options, api) {
    return new (0, $1S4f7.SafePlugin)({
        key: $8d1c5078b4947753$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($8d1c5078b4947753$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $cKEEj.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node, view, getPos, decorations)=>{
                    return (0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
                        exposure: true
                    }) ? new (0, $lhIns.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api
                    }) : (0, $bT1qC.getInlineNodeViewProducer)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        Component: (0, $f7ugX.EmojiNodeView),
                        extraComponentProps: {
                            providerFactory: pmPluginFactoryParams.providerFactory,
                            options: options,
                            api: api
                        }
                    })(node, view, getPos, decorations);
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $8d1c5078b4947753$export$1572b3eade6662f9?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $8d1c5078b4947753$export$1572b3eade6662f9?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $8d1c5078b4947753$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$8d1c5078b4947753$export$1572b3eade6662f9?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("kQc80", function(module, exports) {

$parcel$export(module.exports, "createEmojiFragment", () => $86388d1937acfc41$export$c62c7770bca4be17);
$parcel$export(module.exports, "insertEmoji", () => $86388d1937acfc41$export$8d5c072327044b6f);

var $d925B = parcelRequire("d925B");

var $bYZ53 = parcelRequire("bYZ53");

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $gWR1e = parcelRequire("gWR1e");

var $dh538 = parcelRequire("dh538");
const $86388d1937acfc41$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $kviC1.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $86388d1937acfc41$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                let fragment;
                if ((0, $dh538.fg)('editor_inline_comments_paste_insert_nodes')) fragment = $86388d1937acfc41$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                else {
                    const node = emoji.createChecked({
                        ...emojiId,
                        text: emojiId.fallback || emojiId.shortName
                    });
                    const textNode = doc.type.schema.text(' ');
                    fragment = (0, $kviC1.Fragment).fromArray([
                        node,
                        textNode
                    ]);
                }
                const newTr = (0, $gWR1e.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $7T7aA.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };

});

parcelRegister("f7ugX", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeView", () => $fce311ba02c2ce87$export$cadc6675ce598ba8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ig7BH = parcelRequire("ig7BH");

var $1Oo9w = parcelRequire("1Oo9w");

var $4RzO1 = parcelRequire("4RzO1");

var $heGVP = parcelRequire("heGVP");
const $fce311ba02c2ce87$var$EmojiAssistiveTextComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ emojiShortName: emojiShortName })=>{
    const intl = (0, $dBxQj.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        style: {
            fontSize: 0
        },
        children: `${intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${emojiShortName}`
    }));
});
const $fce311ba02c2ce87$var$useEmojiProvider = (pluginInjectionApi)=>{
    const { emojiState: emojiState } = (0, $1Oo9w.useSharedPluginState)(pluginInjectionApi, [
        'emoji'
    ]);
    return emojiState?.emojiProvider;
};
function $fce311ba02c2ce87$export$cadc6675ce598ba8(props) {
    const { shortName: shortName, id: id, text: text } = props.node.attrs;
    const emojiProvider = $fce311ba02c2ce87$var$useEmojiProvider(props.api);
    if (props.options?.emojiNodeDataProvider) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $heGVP.NdpEmoji), {
        node: props.node,
        emojiNodeDataProvider: props.options.emojiNodeDataProvider
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($fce311ba02c2ce87$var$EmojiAssistiveTextComponent, {
                emojiShortName: shortName
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4RzO1.default), {
                    emojiProvider: emojiProvider,
                    providers: props.providerFactory,
                    id: id,
                    shortName: shortName,
                    fallback: text
                })
            })
        ]
    });
}

});
parcelRegister("ig7BH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2faac4f2f00836b4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2faac4f2f00836b4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});

});

parcelRegister("4RzO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4132531bed0d16a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $2sA5j = parcelRequire("2sA5j");
// eslint-disable-next-line
const $4132531bed0d16a8$var$clickSelectWrapperStyle = (0, $3jLHL.css)`
	user-select: all;
`;
function $4132531bed0d16a8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $4132531bed0d16a8$var$clickSelectWrapperStyle
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2sA5j.default), props));
}

});
parcelRegister("2sA5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f8b0c1361f9945$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $etuMO = parcelRequire("etuMO");
const $28f8b0c1361f9945$var$EmojiNodeFunctional = (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $gwFzn.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $gwFzn.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        children: fallback || shortName
    });
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $etuMO.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true
    });
};
const $28f8b0c1361f9945$var$EmojiNode = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $7UHDa.jsx)($28f8b0c1361f9945$var$EmojiNodeFunctional, {
        ...props
    });
};
var $28f8b0c1361f9945$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($28f8b0c1361f9945$var$EmojiNode);

});


parcelRegister("heGVP", function(module, exports) {

$parcel$export(module.exports, "NdpEmoji", () => $db8f0e7651e2db8d$export$db4bcf62e35bdf65);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dBxQj = parcelRequire("dBxQj");

var $ig7BH = parcelRequire("ig7BH");

var $1kS4J = parcelRequire("1kS4J");

var $7NfJr = parcelRequire("7NfJr");
function $db8f0e7651e2db8d$export$db4bcf62e35bdf65(props) {
    const emojiNode = props.node;
    const value = (0, $1kS4J.useNodeDataProviderGet)({
        node: emojiNode,
        provider: props.emojiNodeDataProvider
    });
    if (value.state === 'loading') return /*#__PURE__*/ (0, $3jLHL.jsx)($db8f0e7651e2db8d$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7NfJr.LoadableSimpleEmojiPlaceholder), {
        shortName: emojiNode.attrs.shortName
    }));
    if (value.state === 'failed') return /*#__PURE__*/ (0, $3jLHL.jsx)($db8f0e7651e2db8d$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, emojiNode.attrs.text || emojiNode.attrs.shortName));
    return /*#__PURE__*/ (0, $3jLHL.jsx)($db8f0e7651e2db8d$var$EmojiCommonWrapper, {
        emojiNode: emojiNode
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7NfJr.LoadableSimpleEmoji), {
        emojiDescription: value.result
    }));
}
const $db8f0e7651e2db8d$var$clickSelectWrapperStyle = (0, $3jLHL.css)({
    userSelect: 'all'
});
const $db8f0e7651e2db8d$var$EmojiAssistiveTextComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ emojiShortName: emojiShortName })=>{
    const intl = (0, $dBxQj.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        style: {
            fontSize: 0
        }
    }, `${intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${emojiShortName}`));
});
function $db8f0e7651e2db8d$var$EmojiCommonWrapper({ emojiNode: emojiNode, children: children }) {
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)($db8f0e7651e2db8d$var$EmojiAssistiveTextComponent, {
        emojiShortName: emojiNode.attrs.shortName
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", null, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $db8f0e7651e2db8d$var$clickSelectWrapperStyle
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        "data-emoji-id": emojiNode.attrs.id,
        "data-emoji-short-name": emojiNode.attrs.shortName,
        "data-emoji-text": emojiNode.attrs.text || emojiNode.attrs.shortName
    }, children))));
}

});
parcelRegister("1kS4J", function(module, exports) {

$parcel$export(module.exports, "useNodeDataProviderGet", () => $b728cf6dbd7d743e$export$7fc1eff72c5dcf09);

var $gwFzn = parcelRequire("gwFzn");
function $b728cf6dbd7d743e$export$7fc1eff72c5dcf09(options) {
    const getResult = (0, $gwFzn.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ()=>options.provider.get(options.node), [
        options.provider,
        options.node
    ]);
    const [resolved, setResolved] = (0, $gwFzn.useState)(getResult !== undefined && !$b728cf6dbd7d743e$var$isPromise(getResult) ? getResult : undefined);
    (0, $gwFzn.useEffect)(()=>{
        if (!$b728cf6dbd7d743e$var$isPromise(getResult)) return;
        let cancelled = false;
        (async function() {
            try {
                const resolved = await getResult;
                if (!cancelled) {
                    if (resolved === undefined) setResolved('error');
                    else setResolved(resolved);
                }
            } catch  {
                setResolved('error');
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        getResult
    ]);
    if (resolved === undefined) return {
        state: 'loading',
        result: undefined
    };
    if (resolved === 'error') return {
        state: 'failed',
        result: undefined
    };
    return {
        state: 'resolved',
        result: resolved
    };
}
function $b728cf6dbd7d743e$var$isPromise(obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && // @ts-ignore
    typeof obj.then === 'function';
}

});

parcelRegister("7NfJr", function(module, exports) {

$parcel$export(module.exports, "LoadableSimpleEmoji", () => $a73640794b1565f0$export$5700b762107b468b);
$parcel$export(module.exports, "LoadableSimpleEmojiPlaceholder", () => $a73640794b1565f0$export$ede5f7e96335247e);

var $4wH3g = parcelRequire("4wH3g");

const $a73640794b1565f0$export$5700b762107b468b = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "5Vvvk",
    name: "LoadableSimpleEmoji",
    loader: ()=>(parcelRequire("9pmDI")).then((component)=>component.SimpleEmoji),
    loading: ()=>null
});

const $a73640794b1565f0$export$ede5f7e96335247e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "_Tmk_",
    name: "LoadableSimpleEmojiPlaceholder",
    loader: ()=>(parcelRequire("9pmDI")).then((component)=>component.SimpleEmojiPlaceholder),
    loading: ()=>null
});

});
parcelRegister("9pmDI", function(module, exports) {

let $6d980299971b447d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d980299971b447d$var$load("h9hWQ").then(()=>parcelRequire('c5zgi'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});






parcelRegister("j0XxS", function(module, exports) {

$parcel$export(module.exports, "emojiNodeSpec", () => $ef49a6b5d9cf65a1$export$d122e24cc43292f6);
$parcel$export(module.exports, "emojiToDom", () => $ef49a6b5d9cf65a1$export$9edeb07c311f4561);

var $VrJSs = parcelRequire("VrJSs");

var $24P9d = parcelRequire("24P9d");
const $ef49a6b5d9cf65a1$var$isSSR = Boolean(undefined);
const $ef49a6b5d9cf65a1$export$d122e24cc43292f6 = ()=>{
    if ($ef49a6b5d9cf65a1$var$isSSR) return 0, $VrJSs.emoji;
    return {
        ...(0, $VrJSs.emoji),
        toDOM: (node)=>$ef49a6b5d9cf65a1$export$9edeb07c311f4561(node)
    };
};
function $ef49a6b5d9cf65a1$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $24P9d.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #091E420F)",
            minWidth: `20px`,
            width: `20px`,
            height: `20px`,
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #091E420F)",
            borderRadius: "var(--ds-border-radius-100, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    return [
        'span',
        attrs
    ];
}

});

parcelRegister("lhIns", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeView", () => $14dc3fa642295a9f$export$cadc6675ce598ba8);

var $eTj7Y = parcelRequire("eTj7Y");

var $fhsiz = parcelRequire("fhsiz");
var $98HrB = parcelRequire("98HrB");
var $ig7BH = parcelRequire("ig7BH");

var $hWRJP = parcelRequire("hWRJP");

var $kviC1 = parcelRequire("kviC1");

var $iu6m9 = parcelRequire("iu6m9");

var $j0XxS = parcelRequire("j0XxS");
function $14dc3fa642295a9f$export$1d677781db73ff20(fallbackText) {
    // Regular expression to match a single emoji character
    const emojiRegex = RegExp("^(\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\u{FE0F}?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
    return emojiRegex.test(fallbackText);
}
class $14dc3fa642295a9f$export$cadc6675ce598ba8 {
    static logError(error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const emojiRepresentation = emojiDescription?.representation;
            if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation);
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
            // Each vanilla JS node implementation should have this data attribute
            this.domElement.setAttribute('data-prosemirror-node-view-type', 'vanilla');
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        const fallbackElement = document.createElement('span');
        fallbackElement.innerText = this.node.attrs.text || this.node.attrs.shortName;
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${this.node.attrs.shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'sprite' in representation ? 'sprite' : 'image';
        // Add wrapper for the emoji
        const containerElement = document.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
    }
    createSpriteEmojiElement(representation) {
        const spriteElement = document.createElement('span');
        spriteElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.width = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.height = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $fhsiz.defaultEmojiHeight}px`;
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        const imageElement = document.createElement('img');
        imageElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        if (representation.width && representation.height) {
            imageElement.height = (0, $fhsiz.defaultEmojiHeight);
            // Because img.width is round to the nearest integer.
            imageElement.setAttribute('width', `${(0, $fhsiz.defaultEmojiHeight) / representation.height * representation.width}`);
        }
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
        // mark the node to refresh when returning online.
        imageElement.onerror = ()=>{
            // Create a check that confirms if this.node.attrs.text if an ascii emoji
            if ($14dc3fa642295a9f$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
            else this.renderingFallback = true;
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api });
   */ constructor(node, { intl: intl, api: api }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.destroy = ()=>{};
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $kviC1.DOMSerializer).renderSpec(document, (0, $j0XxS.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if ((0, $eTj7Y.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
        // that's why we don't need to continue node rendering.
        // In SSR we want to show a placeholder, that `emojiToDom()` returns.
        return;
        // We use the `emojiProvider` from the shared state
        // because it supports the `emojiProvider` prop in the `ComposableEditor` options
        // as well as the `emojiProvider` in the `EmojiPlugin` options.
        const sharedState = api?.emoji?.sharedState;
        if (!sharedState) return;
        let emojiProvider = sharedState.currentState()?.emojiProvider;
        if (emojiProvider) this.updateDom(emojiProvider);
        const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
            return;
            emojiProvider = nextSharedState?.emojiProvider;
            this.updateDom(emojiProvider);
        });
        // Refresh emojis if we go back online
        const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            if (prevSharedState?.mode === 'offline' && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
        });
        this.destroy = ()=>{
            unsubscribe();
            subscribeToConnection?.();
        };
    }
}

});

parcelRegister("cKEEj", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $38eca9ebbfac95ba$export$92a1a3b7554e9387);
$parcel$export(module.exports, "setAsciiMap", () => $38eca9ebbfac95ba$export$5e8f481ab8296997);
$parcel$export(module.exports, "openTypeAhead", () => $38eca9ebbfac95ba$export$adbec20dbbf15a6b);
$parcel$export(module.exports, "setProvider", () => $38eca9ebbfac95ba$export$1572b3eade6662f9);
$parcel$export(module.exports, "setInlineEmojiPopupOpen", () => $38eca9ebbfac95ba$export$f53f9c9a74ec859b);

var $hcboS = parcelRequire("hcboS");
const $38eca9ebbfac95ba$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $38eca9ebbfac95ba$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $38eca9ebbfac95ba$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $38eca9ebbfac95ba$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $38eca9ebbfac95ba$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });

});

parcelRegister("cTFYB", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $4f54215972d22941$export$568a7ed6897c4817);

var $d925B = parcelRequire("d925B");

var $1S4f7 = parcelRequire("1S4f7");

var $l03WE = parcelRequire("l03WE");

var $7T7aA = parcelRequire("7T7aA");

var $aIMBk = parcelRequire("aIMBk");
var $14sLv = parcelRequire("14sLv");
let $4f54215972d22941$var$matcher;
function $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi) {
    if (schema.nodes.emoji) {
        $4f54215972d22941$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $l03WE.createRule)($4f54215972d22941$var$AsciiEmojiMatcher.REGEX, $4f54215972d22941$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4f54215972d22941$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4f54215972d22941$var$matcher = new $4f54215972d22941$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4f54215972d22941$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4f54215972d22941$var$matcher) return null;
        const match = $4f54215972d22941$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4f54215972d22941$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4f54215972d22941$var$getLeadingString = (match, withParenthesis = true)=>match[$4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4f54215972d22941$var$getLeadingStringWithoutParentheses = (match)=>$4f54215972d22941$var$getLeadingString(match, false);
const $4f54215972d22941$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4f54215972d22941$var$getAsciiWithParentheses = (matchParts)=>$4f54215972d22941$var$getAscii(matchParts, true);
const $4f54215972d22941$var$getTrailingString = (match)=>match[$4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingStringWithoutParentheses(matchParts), $4f54215972d22941$var$getAsciiWithParentheses(matchParts), $4f54215972d22941$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingString(matchParts), $4f54215972d22941$var$getAscii(matchParts), $4f54215972d22941$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3}( ))$`);
class $4f54215972d22941$var$RecordingAsciiEmojiMatcher extends $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4f54215972d22941$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).ASCII
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4f54215972d22941$export$77b371d6becc8882 = new (0, $7T7aA.PluginKey)('asciiEmojiPlugin');
const $4f54215972d22941$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4f54215972d22941$export$2e2bcd8739ae039 = $4f54215972d22941$var$plugins;

});

parcelRegister("aFWfo", function(module, exports) {

$parcel$export(module.exports, "InlineEmojiPopupOld", () => $5da86e14354f1f0f$export$b7ec9ebb3bbf8534);
$parcel$export(module.exports, "InlineEmojiPopup", () => $5da86e14354f1f0f$export$295b54f3ba0abfa5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $d925B = parcelRequire("d925B");

var $kuh1P = parcelRequire("kuh1P");

var $1Oo9w = parcelRequire("1Oo9w");

var $jwWgu = parcelRequire("jwWgu");

var $efG2U = parcelRequire("efG2U");

var $b3YrF = parcelRequire("b3YrF");

var $aFUXX = parcelRequire("aFUXX");

var $fnia6 = parcelRequire("fnia6");

var $dh538 = parcelRequire("dh538");

var $cKEEj = parcelRequire("cKEEj");
const $5da86e14354f1f0f$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $5da86e14354f1f0f$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $5da86e14354f1f0f$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $1Oo9w.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $gwFzn.useCallback)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $gwFzn.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $gwFzn.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $gwFzn.useCallback)(()=>{
        editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $gwFzn.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $gwFzn.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $gwFzn.useMemo)(()=>(0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5da86e14354f1f0f$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});

});


parcelRegister("vxKdN", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => $e80fd63e182a8c04$export$fae834324d89b92);

var $3sY9d = parcelRequire("3sY9d");
var $4SZyh = parcelRequire("4SZyh");
var $faMeF = parcelRequire("faMeF");
var $cPaCL = parcelRequire("cPaCL");
var $jHy5g = parcelRequire("jHy5g");
var $eYrrm = parcelRequire("eYrrm");

var $2gkmX = parcelRequire("2gkmX");
var $bT1qC = parcelRequire("bT1qC");

var $1S4f7 = parcelRequire("1S4f7");

var $iq4lN = parcelRequire("iq4lN");

var $7T7aA = parcelRequire("7T7aA");

var $hfXUJ = parcelRequire("hfXUJ");
const $e80fd63e182a8c04$var$pluginKey = new (0, $7T7aA.PluginKey)('unsupportedContentPlugin');
const $e80fd63e182a8c04$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
    return new (0, $1S4f7.SafePlugin)({
        key: $e80fd63e182a8c04$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $2gkmX.default).fromComponent((0, $iq4lN.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $bT1qC.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $hfXUJ.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $2gkmX.default).fromComponent((0, $iq4lN.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $bT1qC.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $hfXUJ.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
const $e80fd63e182a8c04$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $jHy5g.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $eYrrm.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $3sY9d.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $4SZyh.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $faMeF.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $cPaCL.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $e80fd63e182a8c04$var$createPlugin
                }
            ];
        }
    });

});
parcelRegister("hfXUJ", function(module, exports) {

$parcel$export(module.exports, "UnsupportedInlineNodeView", () => $3475f4bb0180772c$export$b963567668795b80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $gndLe = parcelRequire("gndLe");
const $3475f4bb0180772c$export$b963567668795b80 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gndLe.default), props);
};

});


parcelRegister("hI2Bx", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => (parcelRequire("vxKdN")).unsupportedContentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $vxKdN = parcelRequire("vxKdN");

});

parcelRegister("gVoWJ", function(module, exports) {

$parcel$export(module.exports, "createDefaultPreset", () => $836251edf00fa846$export$4efc99f259929bff);
// #region Imports

var $bupcf = parcelRequire("bupcf");

var $hEicH = parcelRequire("hEicH");

var $jL0bJ = parcelRequire("jL0bJ");

var $2P8JV = parcelRequire("2P8JV");

var $stVm3 = parcelRequire("stVm3");

var $cNucV = parcelRequire("cNucV");

var $d2gjm = parcelRequire("d2gjm");

var $1mT7b = parcelRequire("1mT7b");

var $czo2Z = parcelRequire("czo2Z");

var $jiT42 = parcelRequire("jiT42");
parcelRequire("bgrAk");
var $kbe7k = parcelRequire("kbe7k");

var $7aKg5 = parcelRequire("7aKg5");

var $8exqI = parcelRequire("8exqI");

var $12MPQ = parcelRequire("12MPQ");
parcelRequire("4S3gx");
var $l7rln = parcelRequire("l7rln");

var $1AOco = parcelRequire("1AOco");

var $h6Mwq = parcelRequire("h6Mwq");

var $eKfhS = parcelRequire("eKfhS");

var $ebElI = parcelRequire("ebElI");
parcelRequire("ksuJ7");
var $6AqNX = parcelRequire("6AqNX");

var $3HEm4 = parcelRequire("3HEm4");

var $lSIzP = parcelRequire("lSIzP");
parcelRequire("koT39");
var $itirX = parcelRequire("itirX");

var $k2RCe = parcelRequire("k2RCe");

var $cW0VI = parcelRequire("cW0VI");
parcelRequire("chY2a");
var $7nKrc = parcelRequire("7nKrc");
parcelRequire("d5O4W");
var $6borH = parcelRequire("6borH");
parcelRequire("inOAE");
var $5mDFx = parcelRequire("5mDFx");

var $1hEK8 = parcelRequire("1hEK8");

var $7oMzO = parcelRequire("7oMzO");
parcelRequire("hI2Bx");
var $vxKdN = parcelRequire("vxKdN");

var $8C4KP = parcelRequire("8C4KP");

var $dh538 = parcelRequire("dh538");

var $1oCLl = parcelRequire("1oCLl");

var $geLSP = parcelRequire("geLSP");
function $836251edf00fa846$export$4efc99f259929bff(options) {
    const isFullPage = (0, $geLSP.isFullPage)(options.appearance);
    const preset = new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $jL0bJ.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $stVm3.betterTypeHistoryPlugin)).add([
        (0, $3HEm4.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $1mT7b.clipboardPlugin)).add((0, $h6Mwq.focusPlugin)).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ], ()=>(0, $dh538.fg)('platform_editor_use_preferences_plugin')).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(options?.__livePage) ? (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init') : (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)).add((0, $jiT42.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $2P8JV.basePlugin),
        options.base
    ]).add((0, $8exqI.decorationsPlugin)).add([
        (0, $1hEK8.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $eKfhS.historyPlugin), Boolean(options.allowUndoRedoButtons)).add([
        (0, $itirX.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).maybeAdd((0, $7oMzO.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).add([
        (0, $cNucV.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $d2gjm.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $ebElI.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $8C4KP.widthPlugin)).add([
        (0, $k2RCe.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $lSIzP.placeholderPlugin),
        options.placeholder
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $12MPQ.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $6borH.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $7aKg5.copyButtonPlugin)).add((0, $1AOco.floatingToolbarPlugin)).add([
        (0, $cW0VI.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $czo2Z.codeBlockPlugin),
        options.codeBlock
    ]);
    return preset;
}
function $836251edf00fa846$export$a3add99b7c13b8f7(props) {
    const preset = $836251edf00fa846$export$4efc99f259929bff(props);
    return [
        preset
    ];
}

});
parcelRegister("hEicH", function(module, exports) {

$parcel$export(module.exports, "userPreferencesPlugin", () => $7a657067d403e4ad$export$b2ef360f69e1145b);

var $8imsz = parcelRequire("8imsz");

var $kB26S = parcelRequire("kB26S");

var $lbHc1 = parcelRequire("lbHc1");

var $huOaR = parcelRequire("huOaR");

var $76wha = parcelRequire("76wha");

var $4GgXx = parcelRequire("4GgXx");
const $7a657067d403e4ad$export$b2ef360f69e1145b = ({ config: config, api: api })=>{
    const userPreferencesProvider = config.userPreferencesProvider;
    return {
        name: 'userPreferences',
        pmPlugins () {
            return [
                {
                    name: 'userPreferencesPlugin',
                    plugin: ()=>{
                        return (0, $lbHc1.createPlugin)(config, api);
                    }
                }
            ];
        },
        actions: {
            updateUserPreference: (key, value)=>{
                return (0, $kB26S.updateUserPreference)({
                    key: key,
                    value: value,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                });
            }
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $lbHc1.userPreferencesPluginKey).getState(editorState);
        },
        usePluginHook ({ editorView: editorView }) {
            const { resolvedUserPreferences: resolvedUserPreferences } = (0, $8imsz.useResolvedUserPreferences)(userPreferencesProvider);
            (0, $4GgXx.useUserPreferencesUpdateListener)(editorView, resolvedUserPreferences);
            (0, $huOaR.useDocumentVisibilityWatcher)(userPreferencesProvider);
            (0, $76wha.useUserPreferencesInitListener)(Boolean(userPreferencesProvider?.isInitialized), resolvedUserPreferences, api);
        }
    };
};

});
parcelRegister("8imsz", function(module, exports) {

$parcel$export(module.exports, "useResolvedUserPreferences", () => $b9bd51baba75fd69$export$b5633b5b7afd4542);

var $gwFzn = parcelRequire("gwFzn");
function $b9bd51baba75fd69$export$b5633b5b7afd4542(userPreferencesProvider) {
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $gwFzn.useState)(userPreferencesProvider?.getPreferences() || null);
    (0, $gwFzn.useEffect)(()=>{
        return userPreferencesProvider?.onUpdate(()=>{
            setResolvedUserPreferences(userPreferencesProvider.getPreferences());
        });
    }, [
        userPreferencesProvider
    ]);
    return {
        resolvedUserPreferences: resolvedUserPreferences
    };
}

});

parcelRegister("kB26S", function(module, exports) {

$parcel$export(module.exports, "updateUserPreference", () => $dabc3407d69b6572$export$32e4436123e4fc74);

var $d925B = parcelRequire("d925B");

var $hWRJP = parcelRequire("hWRJP");

var $lbHc1 = parcelRequire("lbHc1");
const $dabc3407d69b6572$export$32e4436123e4fc74 = ({ key: key, value: value, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        try {
            userPreferencesProvider?.updatePreference(key, value);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-plugin-user-preferences/userPreferencesPlugin'
            });
        }
        // If the userPreferencesProvider is not available,
        // the plugin's state will be updated to operate in 'in memory' mode.
        tr.setMeta((0, $lbHc1.userPreferencesPluginKey), {
            preferences: {
                [key]: value
            }
        });
        if (key === 'toolbarDockingPosition') editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).UPDATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: value
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };

});
parcelRegister("lbHc1", function(module, exports) {

$parcel$export(module.exports, "userPreferencesPluginKey", () => $853af264aab12b2b$export$26bf7aeec579553f);
$parcel$export(module.exports, "createPlugin", () => $853af264aab12b2b$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $iu6m9 = parcelRequire("iu6m9");
const $853af264aab12b2b$export$26bf7aeec579553f = new (0, $7T7aA.PluginKey)('userPreferencesPlugin');
const $853af264aab12b2b$export$ae829ec7b2625219 = (pluginOptions, _api)=>{
    const { userPreferencesProvider: userPreferencesProvider, initialUserPreferences: initialUserPreferences } = pluginOptions;
    const getInitialUserPreferences = ()=>{
        if (initialUserPreferences && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return initialUserPreferences;
        return {
            toolbarDockingPosition: 'top'
        };
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $853af264aab12b2b$export$26bf7aeec579553f,
        state: {
            init () {
                return {
                    preferences: userPreferencesProvider?.getPreferences() || getInitialUserPreferences()
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($853af264aab12b2b$export$26bf7aeec579553f);
                if (meta?.preferences) return {
                    ...currentPluginState,
                    preferences: {
                        ...currentPluginState.preferences,
                        ...meta.preferences
                    }
                };
                return currentPluginState;
            }
        }
    });
};

});


parcelRegister("huOaR", function(module, exports) {

$parcel$export(module.exports, "useDocumentVisibilityWatcher", () => $dd77f5c6ef9e2e7f$export$c3ff777471586be2);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $hWRJP = parcelRequire("hWRJP");
const $dd77f5c6ef9e2e7f$export$c3ff777471586be2 = (userPreferencesProvider)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (userPreferencesProvider) {
            const refreshPreferences = async ()=>{
                if (document.visibilityState === 'visible') try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $hWRJP.logException)(error, {
                        location: 'editor-plugin-user-preferences/userPreferencesPlugin'
                    });
                }
            };
            return (0, $d8F95.bind)(document, {
                type: 'visibilitychange',
                listener: refreshPreferences
            });
        }
    }, [
        userPreferencesProvider
    ]);
};

});

parcelRegister("76wha", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesInitListener", () => $2fa57ad8231f2b94$export$2bd306fd54c8196e);

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");
const $2fa57ad8231f2b94$export$2bd306fd54c8196e = (isInitialized, resolvedUserPreferences, api)=>{
    const isInitializedRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (isInitialized && resolvedUserPreferences && !isInitializedRef.current) {
            isInitializedRef.current = true;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).INITIALISED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                attributes: {
                    toolbarDocking: resolvedUserPreferences.toolbarDockingPosition
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
    }, [
        api,
        isInitialized,
        resolvedUserPreferences
    ]);
};

});

parcelRegister("4GgXx", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesUpdateListener", () => $739ed6292b62a46a$export$c4b185fa097d4dc);

var $gwFzn = parcelRequire("gwFzn");

var $lbHc1 = parcelRequire("lbHc1");
const $739ed6292b62a46a$export$c4b185fa097d4dc = (editorView, resolvedUserPreferences)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (resolvedUserPreferences) editorView.dispatch(editorView.state.tr.setMeta((0, $lbHc1.userPreferencesPluginKey), {
            preferences: resolvedUserPreferences
        }));
    }, [
        resolvedUserPreferences,
        editorView
    ]);
};

});


parcelRegister("bgrAk", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => (parcelRequire("kbe7k")).contextIdentifierPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kbe7k = parcelRequire("kbe7k");

});

parcelRegister("ksuJ7", function(module, exports) {

$parcel$export(module.exports, "interactionPlugin", () => (parcelRequire("6AqNX")).interactionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6AqNX = parcelRequire("6AqNX");

});
parcelRegister("6AqNX", function(module, exports) {

$parcel$export(module.exports, "interactionPlugin", () => $d25dda4ec15a5e92$export$f92f816359ce0a38);

var $51cpB = parcelRequire("51cpB");
const $d25dda4ec15a5e92$export$f92f816359ce0a38 = ()=>{
    return {
        name: 'interaction',
        getSharedState (editorState) {
            if (!editorState) return {
                // Clean up with platform_editor_interaction_api_refactor
                hasHadInteraction: false,
                interactionState: 'hasNotHadInteraction'
            };
            return {
                // Clean up with platform_editor_interaction_api_refactor
                hasHadInteraction: Boolean((0, $51cpB.key).getState(editorState)?.hasHadInteraction),
                /**
				 * Interaction state can either be null or 'hasNotHadInteraction'. We
				 * are specifically only returning an explicit value for 'hasNotHadInteraction'
				 * because behaviour should only change when the user has _not_ ineteracted
				 * with the editor. The behaviour of when `hasHadInteraction` is true and
				 * when the plugin is undefined should be the same.
				 */ interactionState: (0, $51cpB.key).getState(editorState)?.hasHadInteraction ? null : 'hasNotHadInteraction'
            };
        },
        commands: {
            handleInteraction: ({ tr: tr })=>{
                return tr.setMeta((0, $51cpB.key), {
                    hasHadInteraction: true
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'interactionHandlerPlugin',
                    plugin: (0, $51cpB.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("51cpB", function(module, exports) {

$parcel$export(module.exports, "key", () => $b913d4d013f6b599$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $b913d4d013f6b599$export$ae829ec7b2625219);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");
const $b913d4d013f6b599$export$df61b30b684217c0 = new (0, $7T7aA.PluginKey)('interactionPluginHandler');
const $b913d4d013f6b599$var$handleInteraction = (view)=>{
    const interactionState = $b913d4d013f6b599$export$df61b30b684217c0.getState(view.state);
    if (!interactionState?.hasHadInteraction) view.dispatch(view.state.tr.setMeta($b913d4d013f6b599$export$df61b30b684217c0, {
        hasHadInteraction: true
    }));
    return false;
};
const $b913d4d013f6b599$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $b913d4d013f6b599$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasHadInteraction: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($b913d4d013f6b599$export$df61b30b684217c0);
                if (typeof meta === 'object') {
                    if (meta.hasHadInteraction !== oldPluginState.hasHadInteraction) return {
                        hasHadInteraction: meta.hasHadInteraction
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                // Handle all pointer click events (includes drag inside editor)
                mousedown: $b913d4d013f6b599$var$handleInteraction,
                // Handle keyboard events. Must be keyup to handle tabbing into editor (keyup occurs
                // on the "next focused" element)
                keyup: $b913d4d013f6b599$var$handleInteraction,
                // Handle drag and drop _into_ the editor from outside. Eg image DnD
                drop: $b913d4d013f6b599$var$handleInteraction,
                focus: (0, $dh538.fg)('platform_editor_interaction_api_refactor') ? $b913d4d013f6b599$var$handleInteraction : undefined
            }
        }
    });

});



parcelRegister("koT39", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => (parcelRequire("itirX")).primaryToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $itirX = parcelRequire("itirX");

});

parcelRegister("chY2a", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarPlugin", () => (parcelRequire("7nKrc")).selectionToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7nKrc = parcelRequire("7nKrc");

});

parcelRegister("d5O4W", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => (parcelRequire("6borH")).submitEditorPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6borH = parcelRequire("6borH");

});

parcelRegister("inOAE", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => (parcelRequire("5mDFx")).textFormattingPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5mDFx = parcelRequire("5mDFx");

});



//# sourceMappingURL=FullPageEditorComponent.98339f13.js.map
